import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ElementRef,
  TemplateRef,
  SecurityContext,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlantGroupElement } from 'src/app/models/O3AdministrationModels/plant-model';
import { DatePipe } from '@angular/common';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import Swal from 'sweetalert2';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { DtServiceService } from 'src/app/services/dtService.service';
import { MatDialog } from '@angular/material/dialog';
import { PreventiveDialogComponent } from './preventive-dialog/preventive-dialog.component';
import * as XLSX from 'xlsx';
import { CommonService } from 'src/app/services/common.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { EditBtnRenderer } from 'src/app/edit-action-btn-renderer.component';
import { DeleteBtnRenderer } from 'src/app/delete-action-btn-renderer.component';
import { CustomTooltip } from 'src/app/custom-tooltip.component';
import * as moment from 'moment';
import { ActionEditDeleteBtnRenderer } from 'src/app/action-edit-delete-btn-renderer.component';
import { saveAs } from 'file-saver';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { PermissionService } from 'src/backend/services/permission.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { ChecklistDialogComponent } from './checklist-dialog/checklist-dialog.component';
import { ParamaterDialogComponent } from './paramater-dialog/paramater-dialog.component';
import { DocumentManagementService } from 'src/app/services/document-management.service';
import { MatOptionSelectionChange } from '@angular/material/core';
import { prevTaskService } from 'src/app/services/prev-task.service';
import { ActionViewPMHistoryBtnRenderer } from 'src/app/action-view-pm-history-btn-renderer.component';
import { ProductivityService } from 'src/app/services/productivity-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-preventive-maintanance-configuration',
  templateUrl: './preventive-maintanance-configuration.component.html',
  styleUrls: ['./preventive-maintanance-configuration.component.scss'],
})
export class PreventiveMaintananceConfigurationComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('WOTypeTable') ExportWOTypeTable!: ElementRef;
  @ViewChild('TaskTypeTable') ExportTaskTypeTable!: ElementRef;
  @ViewChild('ToolTable') ExportToolTable!: ElementRef;
  @ViewChild('FrequencyTable') ExportFrequencyTable!: ElementRef;
  @ViewChild('TaskTable') ExportTaskTable!: ElementRef;
  @ViewChild('allSelected') private allSelected: any;
  @ViewChild('allSelectedCheckList') private allSelectedCheckList: any;
  @ViewChild('HistoryLogDetails') private HistoryLogDetails!: TemplateRef<any>;
  @ViewChild('HistoryLogDetailsTechnicianTask')
  private HistoryLogDetailsTechnicianTask!: TemplateRef<any>;
  @ViewChild('HistoryLogParameterDetailsTechnicianTask')
  private HistoryLogParameterDetailsTechnicianTask!: TemplateRef<any>;

  panelOpenState = false;
  page = { length: 0, pageIndex: 0, pageSize: 10 };
  WOTypeColumns: string[] = ['ID', 'Name', 'CreatedAt', 'CreatedBy', 'action'];
  toolcolumns: string[] = ['ID', 'Name', 'CreatedAt', 'CreatedBy', 'action'];
  frequencycolumns: string[] = [
    'ID',
    'Name',
    'Duration',
    'CreatedAt',
    'CreatedBy',
    'action',
  ];
  tasktypecolumns: string[] = [
    'ID',
    'Name',
    'MaintenanceType',
    'CreatedAt',
    'CreatedBy',
    'action',
  ];
  taskColumns: string[] = [
    'ID',
    'Unit',
    'Description',
    'Technician',
    'TaskType',
    'Duration',
    'Frequency',
    'WOType',
    'SparePart',
    'CreatedAt',
    'CreatedBy',
    'action',
    'InActive',
  ];
  myFormControl = new FormControl({ value: '', disabled: true });
  ToolDataSource = new MatTableDataSource();
  FrequencyDataSource = new MatTableDataSource();
  TaskTypeDataSource = new MatTableDataSource();
  TaskDataSource = new MatTableDataSource();
  WOTypeDataSource = new MatTableDataSource();
  updateOrderprocessingData = false;
  groupDataForm!: FormGroup;
  formDirective: any;

  displayComponentModal = false;
  MachineId!: any;
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  LineNode: any;
  breadcrumList!: any;
  permisson!: any;
  parameterType!: any[];
  varUnitName!: string;
  isReqired = false;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  edited = false;
  disableToTaskDate = false;
  user: any;
  groupId: any;
  filteredRows!: any;
  filteredRowsData: any = [];
  disableActive = true;
  Active = true;
  IsAdmin: any;
  filteredUsers: any;
  raci: any;
  InActiveValidation = true;
  WOTypePage = { length: 0, pageIndex: 0, pageSize: 5 };
  ToolPage = { length: 0, pageIndex: 0, pageSize: 5 };
  FrequencyPage = { length: 0, pageIndex: 0, pageSize: 5 };
  TaskTypePage = { length: 0, pageIndex: 0, pageSize: 5 };
  TaskPage = { length: 0, pageIndex: 0, pageSize: 5 };
  HeaderData: any = { Group: '', Plant: '' };
  prevTool: any = { Name: '', CreatedAt: '', CreatedBy: 0, ID: 0 };
  prevTaskType: any = {
    Name: '',
    MaintenanceType: '',
    CreatedAt: '',
    CreatedBy: 0,
    ID: 0,
  };
  editMaintenanceType: string;
  editTaskTypeID: any;
  prevTask: any = {
    line: null,
    inActive: null,
    units: null,
    assembly: null,
    subAssembly: null,
    component: null,
    lineName: '',
    unitName: '',
    assemblyName: '',
    subAssemblyName: '',
    componentName: '',
    Description: '',
    Technician: '',
    Frequency: '',
    displayMachine: '',
    Duration: '',
    SpareParts: '',
    UploadFile: '',
    TaskType: '',
    MaintenanceType: '',
    FromTaskDate: '',
    ToTaskDate: '',
    FileType: [],
    CreatedAt: '',
    TechnicianRole: '',
    CreatedBy: 0,
    ID: 0,
    Checklist: '',
  };
  prevFrequency: any = {
    Name: '',
    Duration: '',
    CreatedAt: '',
    CreatedBy: 0,
    ID: 0,
  };
  Technician: any = {
    ID: 0,
    RMPM: 'PM',
    Name: [],
    CreatedAt: new Date(),
    CreatedBy: 0,
  };
  TaskTypeList: any = [];
  ToolList: any = [];
  TaskList: any = [];
  frequencyList: any = [];
  TechnicianList: any = [];
  Arr: any = [];
  plantgroup: any;
  plantgroupFormMode!: boolean;
  newGroupItemParent!: PlantGroupElement;
  addnewGroupModelTitle = '';
  isaddNewGroupItemModelVisible = false;
  filterTechnicianList: any = [];
  TechnicianFiltList: any = [];
  filterFrequencyList: any = [];
  filterTaskTypeList: any = [];
  FreqDuration: any;
  isPlantGroupModelVisible: boolean = false;
  spinnerText: string = '';
  dialogBox: boolean = false;
  imageFile: any;
  imageFileName: any;
  ImageUrl: string = '';
  blobStorageUrl: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  minDate: Date;
  toTaskMinDate: Date;
  HeaderForm = this.fb.group({
    Group: new FormControl(null, [Validators.required]),
    Plant: new FormControl(null, [Validators.required]),
  });
  prevToolForm = this.fb.group({
    name: new FormControl('', [Validators.required]),
  });
  prevFrequencyForm = this.fb.group({
    name: new FormControl('', [Validators.required]),
    duration: new FormControl('', [Validators.required]),
  });
  prevTaskTypeForm = this.fb.group({
    name: new FormControl('', [Validators.required]),
    maintenanceType: new FormControl('', [Validators.required]),
  });
  prevTaskForm = this.fb.group({
    line: new FormControl('', [Validators.required]),
    unit: new FormControl('', [Validators.required]),
    assembly: new FormControl('', [Validators.required]),
    subAssembly: new FormControl('', [Validators.required]),
    component: new FormControl('', [Validators.required]),
    description: ['', Validators.required],
    technicians: [''],
    frequency: ['', Validators.required],
    WOType: ['', Validators.required],
    type_duration: ['', Validators.required],
    spare_part: [''],
    TechnicianRole: [''],
    task_type: ['', Validators.required],
    maintenanceType: ['', Validators.required],
    fromTaskDate: [''],
    toTaskDate: [''],
    checklist: [''],
  });
  WOTypeForm = this.fb.group({
    Name: new FormControl(null, [Validators.required]),
  });
  TechnicianForm!: FormGroup;
  WOTypeList: any = [];
  WOTypeFiltList: any = [];
  AllWOType: any = [];
  isImageFile: boolean = false;
  isVideoFile: boolean = false;
  isApplicationFile: boolean = false;
  GroupList: any = [];
  filteredGroupList: any = [];
  PlantList: any = [];
  filteredPlantList: any = [];
  userList: any = [];
  orgUserList: any = [];
  excelFile: any;
  DepartmentList: any = [];
  availableUsersList: any = [];
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0;
  plantAll: any = [];
  ExcelTechnicianList: any = [];
  ExcelDepartmentList: any = [];
  ExportWOType: any = [];
  ExportTool: any = [];
  ExportFrequency: any = [];
  ExportTaskType: any = [];
  ExportTask: any = [];
  ExportTechnician: any = [];
  TreeData: any = [];
  imageSrc = new Array<string>();
  fileType: any;
  FileData: any = [];
  FileList: any = [];
  EditFileData: any = [];
  TechnologyMasterData: any = [];
  TaskTypeMasterData: any = [];
  FrequencyMasterData: any = [];
  ToolMasterData: any = [];
  TaskMasterData: any = [];
  TechnicianMasterData: any = [];
  AllTaskType: any = [];
  AllFrequency: any = [];
  AllTool: any = [];
  WOType: any = { ID: 0, Name: '', CreatedAt: new Date(), CreatedBy: 0 };
  GroupTempList: any = [];
  PlantTempList: any = [];
  MaintenanceType: any = [
    { ID: 1, Name: 'Time Based' },
    { ID: 2, Name: 'Condition Based' },
  ];
  filteredMaintenanceType: any[] = this.MaintenanceType.slice();
  pageSizeOptions = [5, 10, 20];
  frameworkComponents: any;
  rowData: any = [];
  columnDefsTask!: any[];
  historyLogcolumnDefs!: any[];
  historyLogTechnicianTaskcolumnDefs!: any[];
  historyLogParameterColumnDefs!: any[];
  domLayout = 'autoHeight';
  gridApi: any;
  gridColumnApi: any;
  gridApiPMHistory: any;
  gridColumnApiPMHistory: any;
  gridApiPMTechnicianHistory: any;
  gridColumnApiPMTechnicianHistory: any;
  gridOptions: any = {
    defaultColDef: {
      paginationPageSize: 50,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    rowSelection: 'multiple',
    popupParent: document.querySelector('body'),
  };
  gridOptionsTask: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      minWidth: 150,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
  };
  gridOptionsTechnicianTask: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      minWidth: 150,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
  };
  gridOptionsParameters: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
  };
  rowModelType = 'serverSide';
  serverSideStoreType: any = 'partial';
  oldTaskPageIndex: number;
  LineList: any = [];
  LineFilterList: any = [];
  LineAllList: any = [];
  UnitList: any = [];
  UnitFilterList: any = [];
  UnitAllList: any = [];
  AssemblyList: any = [];
  AssemblyFilterList: any = [];
  AssemblyAllList: any = [];
  SubAssemblyList: any = [];
  SubAssemblyFilterList: any = [];
  SubAssemblyAllList: any = [];
  ComponentList: any = [];
  ComponentFilterList: any = [];
  ComponentAllList: any = [];
  Prevtask: any;
  PrevtaskFilterList: any;
  FrequencyList: any;
  FrequencyFilterList: any;
  TaskTypeList1: any;
  TaskTypeListFilterList: any;
  TechnicianList1: any;
  TechnicianListFilter: any;
  WOTypeList1: any;
  WOTypeListFilterList: any;
  opentype: any;
  lang: any;
  isAccess = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_ACCESS;
  isWrite = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_CREATE;
  isUpdate = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_UPDATE;
  isDelete = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_DELETE;
  activate =
    ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_ACTIVATE;
  deactivate =
    ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_DEACTIVATE;
  plantSession: any;
  groupSession: any;
  userSession: any;

  isInit: boolean;

  plantRoles: any[] = [];

  filterRoles: any[] = [];
  checklists: any[] = [];
  filteredCheckLists: any[] = [];
  Status: string = 'InActive';
  historyLogs: any[] = [];
  historyLogsTechnicianTask: any[] = [];
  historyLogsParameter: any[] = [];
  TaskNamePMHistory: string;
  displayMaximizable: boolean;
  filesToPreview: { url: string, type: string }[] = [];
  currentIndex = 0;
  images: string[] = [];
  imageIndexOne = 0;
  //fileTypePMHistory: 'img' | 'doc' = 'img';
  parameters: any;
  disableFrq: boolean = false;
  existingTaskRow: any;

  fileTypePMHistory: string = '';
  currentFileUrl: SafeResourceUrl | null = null;
  ButtonType: string;
  doc: string;
  constructor(
    private translater: TranslaterService,
    private translate: TranslateService,
    private baseApi: BaseApi,
    private toaster: ToastrService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private documentService: DocumentManagementService,
    private RMConfigurationService: RMconfigurationService,
    public managerExecutionService: ManagerExecutionService,
    private enterpriseGroupService: EnterPriseGroupService,
    private userManagementService: UserManagementService,
    private cilMasterService: CILMasterService,
    private PrevConfigurationService: PrevConfigurationService,
    private dtService: DtServiceService,
    public dialog: MatDialog,
    private commonService: CommonService,
    private prevConfigurationService: PrevConfigurationService,
    private employeeService: EmployeeService,
    private permissionService: PermissionService,
    private prevTaskService: prevTaskService,
    private productivityservice: ProductivityService,
    private sanitizer: DomSanitizer
  ) {
    this.minDate = new Date();
    this.toTaskMinDate = new Date();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });

    this.frameworkComponents = {
      editRenderer: EditBtnRenderer,
      deleteRenderer: DeleteBtnRenderer,
      customTooltip: CustomTooltip,
      actionEditDeleteBtnRenderer: ActionEditDeleteBtnRenderer,
      actionViewPMHistoryBtnRenderer: ActionViewPMHistoryBtnRenderer,
    };

    this.historyLogParameterColumnDefs = [
      {
        headerName: 'TaskDescription',
        filter: true,
        valueGetter: () => this.TaskNamePMHistory,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'Parameter',
        filter: true,
        field: 'ParameterId',
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          const paramId = params.data?.ParameterId;
          const match = this.parameters.find((p: any) => p.Var_Id === paramId);
          return match?.Var_Desc ?? '';
        },
      },
      {
        headerName: 'Actual',
        field: 'Actual',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'LifeSpan',
        field: 'LifeSpan',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'Target',
        field: 'Target',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'Number',
        field: 'RuleNumber',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'Condition',
        field: 'RuleCondition',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'Unit',
        field: 'RuleUnit',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      // {
      //   headerName: 'IsDeleted',
      //   field: 'IsDeleted',
      //   filter: true,
      //   headerValueGetter: this.localizeHeaderJson.bind(this),
      // },
      {
        headerName: 'CreatedAt',
        field: 'CreatedAt',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueFormatter: (params: any) =>
          params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY hh:mm:ss A')
            : '',
      },
      {
        headerName: 'UpdatedAt',
        field: 'UpdatedAt',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueFormatter: (params: any) =>
          params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY hh:mm:ss A')
            : '',
      },
      {
        headerName: 'CreatedBy',
        field: 'CreatedBy',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          const user = this.orgUserList.find(
            (u: any) => u.employeeCode === params.data?.CreatedBy
          );
          return user?.fullName ?? params.data?.CreatedBy ?? '';
        },
      },
      {
        headerName: 'UpdatedBy',
        field: 'UpdatedBy',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          const user = this.orgUserList.find(
            (u: any) => u.employeeCode === params.data?.UpdatedBy
          );
          return user?.fullName ?? params.data?.UpdatedBy ?? '';
        },
      },
    ];

    this.historyLogTechnicianTaskcolumnDefs = [
      {
        headerName: 'TaskDescription',
        filter: true,
        valueGetter: () => this.TaskNamePMHistory,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'Checklists',
        field: 'ChecklistIds',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const ids = params.data?.ChecklistIds?.split(',').map(
              (id: string) => id.trim()
            );
            const checklistMap = new Map(
              this.checklists.map((c: any) => [
                String(c.ChecklistId),
                c.Listname,
              ])
            );
            return ids
              .map((id: string) => checklistMap.get(id))
              .filter((name: string | undefined) => !!name)
              .join(', ');
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Responsible',
        field: 'TaskBy',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          const userId = params.data?.TaskBy;
          const user = this.orgUserList.find(
            (u: any) => u.employeeCode === userId
          );
          return user?.fullName ?? '';
        },
      },
      {
        headerName: 'CreatedAt',
        field: 'CreatedAt',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY hh:mm:ss A') // Local time
            : '';
        },
      },
      {
        headerName: 'TaskExpireTime',
        field: 'TaskExpireTime',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY') // Local time
            : '';
        },
      },
      {
        headerName: 'CreatedBy',
        field: 'CreatedBy',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          const userId = params.data?.CreatedBy;
          const user = this.orgUserList.find(
            (u: any) => u.employeeCode === userId
          );
          return user?.fullName ?? '';
        },
      },
    ];

    this.historyLogcolumnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'actionViewPMHistoryBtnRenderer',
        minWidth: 250,
        cellRendererParams: {
          onClickView: (params: any) => this.viewPMTechTaskRow(params),
          onClickParameterHistory: (params: any) =>
            this.parameterPMTechTaskRow(params),
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'TaskDescription',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].Description ?? '' : '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Technicians',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const technicianIdsStr =
              arr.length > 0 ? arr[0].TechnicianID ?? '' : '';
            if (!technicianIdsStr) return '';

            const technicianIds = technicianIdsStr
              .split(',')
              .map((id) => id.trim());
            const names = technicianIds
              .map((id) => {
                const user = this.orgUserList.find(
                  (u: any) => u.employeeCode === id
                );
                return user?.fullName;
              })
              .filter((name) => !!name)
              .join(', ');

            return names || '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Frequency',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const frequencyId =
              arr.length > 0 ? arr[0].FrequencyID ?? null : null;
            if (!frequencyId) return '';

            const match = this.frequencyList.find(
              (f: any) =>
                f.ID === frequencyId || String(f.ID) === String(frequencyId)
            );
            return match?.Name ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Line',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const id = arr.length > 0 ? arr[0].LineID ?? null : null;
            if (!id) return '';
            const match = this.LineAllList.find(
              (line: any) => line.PL_Id === id
            );
            return match?.PL_Desc ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Unit',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const id = arr.length > 0 ? arr[0].UnitID ?? null : null;
            if (!id) return '';
            const match = this.UnitAllList.find(
              (unit: any) => unit.PU_Id === id
            );
            return match?.PU_Desc ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Assembly',
        headerValueGetter: this.localizeHeaderJson.bind(this),
        field: 'UpdatedPMTaskJson',
        filter: true,
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const id = arr.length > 0 ? arr[0].AssemblyID ?? null : null;
            if (!id) return '';
            const match = this.AssemblyAllList.find(
              (asm: any) => asm.Assbly_Id === id
            );
            return match?.Assbly_Desc ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'SubAssembly',
        headerValueGetter: this.localizeHeaderJson.bind(this),
        field: 'UpdatedPMTaskJson',
        filter: true,
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const id = arr.length > 0 ? arr[0].SubAssemblyID ?? null : null;
            if (!id) return '';
            const match = this.SubAssemblyAllList.find(
              (sub: any) => sub.SAssbly_Id === id
            );
            return match?.SAsbly_Desc ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Component',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const id = arr.length > 0 ? arr[0].ComponentID ?? null : null;
            if (!id) return '';
            const match = this.ComponentAllList.find(
              (comp: any) => comp.ComponentId === id
            );
            return match?.ComponentName ?? '';
          } catch {
            return '';
          }
        },
      },

      {
        headerName: 'Duration',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].Duration ?? '' : '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'SpareParts',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].SpareParts ?? '' : '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Attachments',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].UploadFile ?? '' : '';
          } catch {
            return '';
          }
        },
        cellRenderer: () => {
          return `
      <div style="display: flex;">
        <button
          style="
            color: white;
            background: #3aafe4;
            margin-right: 5px;
            border: none;
            border-radius: 20px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 10px 10px;
          "
          title="View File"
        >
          <i
            class="fa fa-eye"
            aria-hidden="true"
            style="color: white; font-size: 18px;"
          ></i>
        </button>
      </div>
    `;
        },
      },
      {
        headerName: 'CreatedAt',
        field: 'CreatedAt',
        filter: true,
        minWidth: 200,
        // valueGetter: (params: any) => {
        //   try {
        //     const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
        //     return arr.length > 0 ? arr[0]?.CreatedAt ?? '' : '';
        //   } catch {
        //     return '';
        //   }
        // },
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY hh:mm:ss A') // Local time
            : '';
        },
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
      {
        headerName: 'CreatedBy',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const createdById =
              arr.length > 0 ? arr[0].CreatedBy ?? null : null;
            if (!createdById) return '';

            const match = this.orgUserList.find(
              (u: any) => u.employeeCode === createdById
            );
            return match?.fullName ?? '';
          } catch {
            return '';
          }
        },
      },
      // {
      //   headerName: 'NextScheduleAt',
      //   field: 'UpdatedPMTaskJson',
      //   headerValueGetter: this.localizeHeaderJson.bind(this),
      //   valueGetter: (params: any) => {
      //     try {
      //       const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
      //       return arr.length > 0 ? arr[0].NextScheduleAt ?? '' : '';
      //     } catch {
      //       return '';
      //     }
      //   },
      //   valueFormatter: function (params: any) {
      //     return params && params.value
      //       ? moment.utc(params.value).local().format('DD/MM/YYYY hh:mm:ss A') // Local time
      //       : '';
      //   },
      // },
      {
        headerName: 'WOType',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const woTypeId = arr.length > 0 ? arr[0].WOType ?? null : null;
            if (!woTypeId) return '';

            const match = this.WOTypeList.find(
              (w: any) => w.ID === woTypeId || String(w.ID) === String(woTypeId)
            );
            return match?.Name ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'TaskType',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const taskTypeId =
              arr.length > 0 ? arr[0].TaskTypeID ?? null : null;
            if (!taskTypeId) return '';

            const match = this.TaskTypeList.find(
              (t: any) =>
                t.ID === taskTypeId || String(t.ID) === String(taskTypeId)
            );
            return match?.Name ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'MaintenanceType',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].MaintenanceType ?? '' : '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'StartDate',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].StartDate ?? '' : '';
          } catch {
            return '';
          }
        },
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY') // Local time
            : '';
        },
      },
      {
        headerName: 'EndDate',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].EndDate ?? '' : '';
          } catch {
            return '';
          }
        },
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment.utc(params.value).local().format('DD/MM/YYYY') // Local time
            : '';
        },
      },
      {
        headerName: 'TechnicianRoleName',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const roleId =
              arr.length > 0 ? arr[0].TechnicianRoleId ?? null : null;
            if (!roleId) return '';

            const match = this.plantRoles.find(
              (r: any) =>
                r.roleId === roleId || String(r.roleId) === String(roleId)
            );
            return match?.roleName ?? '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'TaskStatus',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            return arr.length > 0 ? arr[0].TaskStatus ?? '' : '';
          } catch {
            return '';
          }
        },
        cellStyle: (params: any) => {
          const status = JSON.parse(
            params.data?.UpdatedPMTaskJson
          )[0]?.TaskStatus.toLowerCase();
          switch (status) {
            case 'live':
              return {
                backgroundColor: 'green',
                color: 'white',
                fontWeight: 'bold',
              };
            case 'active':
              return {
                backgroundColor: 'yellow',
                color: 'black',
                fontWeight: 'bold',
              };
            case 'inactive':
              return {
                backgroundColor: 'red',
                color: 'white',
                fontWeight: 'bold',
              };
            default:
              return {};
          }
        },
      },
      {
        headerName: 'Checklists',
        field: 'UpdatedPMTaskJson',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
        valueGetter: (params: any) => {
          try {
            const arr = JSON.parse(params.data?.UpdatedPMTaskJson);
            const checklistIdsString =
              arr.length > 0 ? arr[0].ChecklistIds ?? '' : '';
            if (!checklistIdsString) return '';

            const checklistMap = new Map(
              this.checklists.map((c: any) => [
                String(c.ChecklistId),
                c.Listname,
              ])
            );

            const checklistNames = checklistIdsString
              .split(',')
              .map((id: string) => checklistMap.get(id.trim()))
              .filter((name: string | undefined) => !!name)
              .join(', ');

            return checklistNames || '';
          } catch {
            return '';
          }
        },
      },
      {
        headerName: 'Remarks',
        field: 'Remarks',
        filter: true,
        headerValueGetter: this.localizeHeaderJson.bind(this),
      },
    ];

    this.columnDefsTask = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'actionEditDeleteBtnRenderer',
        minWidth: 250,
        headerCheckboxSelection: true,
        checkboxSelection: function (params: any) {
          return true;
        },
        cellRendererParams: {
          onClickEdit: this.editTaskRow.bind(this),
          onClickDelete: this.deleteTaskRow.bind(this),
          onClickChecklist: this.openChecklistModal.bind(this),
          onClickParameter: (params: any) => this.openParameterModal(params),
          onClickHistory: (params: any) => this.openHistoryModal(params),
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'InActive',
        minWidth: 150,
        field: 'TaskStatus',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
        cellStyle: (params: any) => {
          switch (params.value) {
            case 'Live':
              return {
                backgroundColor: 'green',
                color: 'white',
                fontWeight: 'bold',
              };
            case 'Active':
              return {
                backgroundColor: 'yellow',
                color: 'black',
                fontWeight: 'bold',
              };
            case 'InActive':
              return {
                backgroundColor: 'red',
                color: 'white',
                fontWeight: 'bold',
              };
            default:
              return {};
          }
        },
      },
      {
        headerName: 'Line',
        minWidth: 150,
        field: 'Line',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Unit',
        minWidth: 150,
        field: 'Unit',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Assembly',
        minWidth: 150,
        field: 'Assembly',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'SubAssembly',
        minWidth: 150,
        field: 'SubAssembly',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Component',
        minWidth: 150,
        field: 'Component',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Description',
        minWidth: 350,
        field: 'Description',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician',
        minWidth: 200,
        field: 'Technician',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'TechnicianRole',
        minWidth: 200,
        field: 'TechnicianRoleName',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'TaskType',
        minWidth: 150,
        field: 'TaskType',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'MaintenanceType',
        minWidth: 150,
        field: 'MaintenanceType',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Duration',
        minWidth: 105,
        field: 'Duration',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Frequency',
        minWidth: 129,
        field: 'Frequency',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Activity Type',
        minWidth: 150,
        field: 'WOType',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts',
        minWidth: 150,
        field: 'SpareParts',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Start Date',
        minWidth: 180,
        field: 'StartDate',
        filter: true,
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment(params.value).format('DD/MM/YYYY')
            : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'To Task Date',
        minWidth: 180,
        field: 'ToTaskDate',
        filter: true,
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment(params.value).format('DD/MM/YYYY')
            : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Creation Date',
        minWidth: 180,
        field: 'CreatedAt',
        filter: true,
        valueFormatter: function (params: any) {
          return params && params.value
            ? moment(params.value).format('DD/MM/YYYY hh:mm a')
            : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created By',
        minWidth: 150,
        field: 'CreatedUser',
        filter: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
      },
      {
        headerName: 'Checklists',
        minWidth: 250,
        field: 'ChecklistIds',
        filter: true,
        cellRenderer: (params: any) => {
          const checklistIds = params.value?.split(',') || [];
          const checklistMap = new Map(
            this.checklists.map((c: any) => [String(c.ChecklistId), c.Listname])
          );

          const checklistNames = checklistIds
            .map((ChecklistId: string) => checklistMap.get(ChecklistId.trim()))
            .filter((Listname: string | undefined) => !!Listname)
            .join(', ');

          return checklistNames || '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }

  ngOnInit(): void {
    this.RMConfigurationService.updateAccess(this.isAccess, this.isWrite);
    this.getLangWords();
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getTool();
    this.getFrequency();
    this.getTaskType();
    this.getWOType();
    this.getUserList();
    this.getTreeMasterData();
    this.openTreeModal();
    this.getRolesByPlant();
    this.getParameters();
    this.TechnicianForm = this.fb.group({
      Name: new FormControl(null, [Validators.required]),
    });
    this.prevTaskForm.get('maintenanceType')?.valueChanges.subscribe(() => {
      this.updateConditionalValidators();
    });

    this.prevTaskType.MaintenanceType = this.MaintenanceType[0].Name;
    this.isInit = true;

    this.prevTaskForm.get('maintenanceType')?.valueChanges.subscribe((val) => {
      if (val?.toLowerCase() === 'condition based') {
        this.prevTaskForm.get('frequency')?.setValue(null);
        this.prevTaskForm.get('frequency')?.disable();
        this.prevTaskForm.get('fromTaskDate')?.setValue(null);
        this.prevTaskForm.get('fromTaskDate')?.disable();
        this.prevTaskForm.get('toTaskDate')?.setValue(null);
        this.prevTaskForm.get('toTaskDate')?.disable();
        this.prevTaskForm.get('type_duration')?.clearValidators();
        this.prevTaskForm.get('type_duration')?.updateValueAndValidity();
      } else {
        this.prevTaskForm.get('frequency')?.enable();
        this.prevTaskForm.get('fromTaskDate')?.enable();
        this.prevTaskForm.get('toTaskDate')?.enable();
        this.prevTaskForm
          .get('type_duration')
          ?.setValidators([Validators.required]);
        this.prevTaskForm.get('type_duration')?.updateValueAndValidity();
      }
    });
  }
  updateConditionalValidators(): void {
    const maintenanceType = this.prevTaskForm.get('maintenanceType')?.value;

    const technicians = this.prevTaskForm.get('technicians');
    const technicianRole = this.prevTaskForm.get('TechnicianRole');
    const fromTaskDate = this.prevTaskForm.get('fromTaskDate');
    const toTaskDate = this.prevTaskForm.get('toTaskDate');

    if (maintenanceType === 'Time Based') {
      // Optional
      technicians?.clearValidators();
      technicianRole?.clearValidators();
      fromTaskDate?.clearValidators();
      toTaskDate?.clearValidators();
      this.isReqired = false;
    } else {
      // Required
      technicians?.setValidators(Validators.required);
      // technicianRole?.setValidators(Validators.required);
      this.isReqired = true;
    }

    // Update validity
    technicians?.updateValueAndValidity();
    technicianRole?.updateValueAndValidity();
    fromTaskDate?.updateValueAndValidity();
    toTaskDate?.updateValueAndValidity();
  }

  //common
  getPaginator(dataSource: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      dataSource.paginator = this.paginator.toArray()[index];
      dataSource.sort = this.sort.toArray()[index];
    }, 500);
  }

  openFile() {
    this.fileInput.nativeElement.click();
  }

  readFile(event: any) {
    const files = event.target.files;
    this.FileList.push(event.target.files[0]);
    if (files) {
      for (let file of files) {
        const fileName = file.name;
        const fileExtension = fileName
          .substring(fileName.lastIndexOf('.') + 1)
          .toLowerCase();

        if (file.type.match('image.*')) {
          this.fileType = 'image';
        } else if (file.type.match('video.*')) {
          this.toaster.warning('Video files are not supported. Please upload only documents or images');
          return;
          //this.fileType = 'video';
        } else if (file.type.match('application.*')) {
          this.fileType = 'application';
        }

        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageSrc = e.target.result;
          this.FileData.push({
            FileType: this.fileType,
            ImageSrc: this.imageSrc,
            FileExtension: fileExtension,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeFile(i: any) {
    this.FileData.splice(i, 1);
    this.FileList.splice(i, 1);
    // Reset the value of the file input to allow selecting the same file again
    const fileInput = this.fileInput.nativeElement;
    fileInput.value = null;
  }

  deleteFile(i: any) {
    this.EditFileData.splice(i, 1);
    this.prevTask.FileType.push(i);
    // Reset the value of the file input to allow selecting the same file again
    const fileInput = this.fileInput.nativeElement;
    fileInput.value = null;
  }

  ExportTOExcel(name: any) {
    if (this.groupSession?.groupCode && this.plantSession?.plantCode) {
      const workBook = XLSX.utils.book_new(); // create a new blank book

      this.ExportWOType =
        this.ExportWOType && this.ExportWOType.length
          ? this.ExportWOType
          : [{ ['Group']: '', ['Plant']: '', ['Activity Type Name']: '' }];
      this.ExportTool =
        this.ExportTool && this.ExportTool.length
          ? this.ExportTool
          : [{ ['Group']: '', ['Plant']: '', ['Tool Name']: '' }];
      this.ExportFrequency =
        this.ExportFrequency && this.ExportFrequency.length
          ? this.ExportFrequency
          : [
            {
              ['Group']: '',
              ['Plant']: '',
              ['Frequency Name']: '',
              ['Duration / days']: '',
            },
          ];

      this.ExportTask =
        this.ExportTask && this.ExportTask.length
          ? this.ExportTask
          : [
            {
              ['Group']: '',
              ['Plant']: '',
              ['Description']: '',
              ['Technician']: '',
              ['Task Type']: '',
              ['Frequency']: '',
              ['Activity Type']: '',
              ['Duration / Min']: '',
              ['Spare Parts']: '',
              ['Line / Unit / Assembly / SubAssembly / Component']: '',
            },
          ];

      this.ExportTaskType =
        this.ExportTaskType && this.ExportTaskType.length
          ? this.ExportTaskType
          : [
            {
              ['Group']: '',
              ['Plant']: '',
              ['Task Type Name']: '',
              ['Maintenance Type']: '',
            },
          ];

      this.ExportTechnician =
        this.ExportTechnician && this.ExportTechnician.length
          ? this.ExportTechnician
          : [{ ['Group']: '', ['Plant']: '', ['Technician']: '' }];

      const ActivityTypeSheet = XLSX.utils.json_to_sheet(this.ExportWOType);
      // const ToolSheet = XLSX.utils.json_to_sheet(this.ExportTool);
      const FrequencySheet = XLSX.utils.json_to_sheet(this.ExportFrequency);
      const TechnicianSheet = XLSX.utils.json_to_sheet(this.ExportTechnician);
      const TaskTypeSheet = XLSX.utils.json_to_sheet(this.ExportTaskType);
      const TaskSheet = XLSX.utils.json_to_sheet(this.ExportTask);

      XLSX.utils.book_append_sheet(
        workBook,
        ActivityTypeSheet,
        'Activity Type'
      ); // add the worksheet to the book
      // XLSX.utils.book_append_sheet(workBook, ToolSheet, 'Tool');
      XLSX.utils.book_append_sheet(workBook, FrequencySheet, 'Frequency');
      XLSX.utils.book_append_sheet(workBook, TechnicianSheet, 'Technician');
      XLSX.utils.book_append_sheet(workBook, TaskTypeSheet, 'TaskType');
      XLSX.utils.book_append_sheet(workBook, TaskSheet, 'Task');
      XLSX.writeFile(workBook, `${name}.xlsx`); // initiate a file
    } else {
      this.toaster.warning('Please Fill Header Fields', 'Warning');
      return;
    }
  }

  tosslePerOne() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (
      this.TechnicianForm.controls.Name.value.length == this.userList.length
    ) {
      this.TechnicianForm.controls.Name.patchValue([
        ...this.userList.map((item) => item.UserId),
        'ALL',
      ]);
    }
  }
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.TechnicianForm.controls.Name.patchValue([
        ...this.userList.map((item) => item.UserId),
        'ALL',
      ]);
    } else {
      this.TechnicianForm.controls.Name.patchValue([]);
    }
  }

  getTreeMasterData() {
    const data = {
      GroupCode: this.groupSession?.groupCode,
      PlantCode: this.plantSession?.plantCode,
    };
    this.spinner.show();
    this.PrevConfigurationService.GetTreeMasterData(data).subscribe(
      (res: any) => {
        if (!this.isInit) this.spinner.hide();
        this.LineAllList = [];
        this.LineList = [];
        this.LineFilterList = [];
        this.UnitAllList = [];
        this.UnitList = [];
        this.UnitFilterList = [];
        this.AssemblyAllList = [];
        this.AssemblyList = [];
        this.AssemblyFilterList = [];
        this.SubAssemblyAllList = [];
        this.SubAssemblyList = [];
        this.SubAssemblyFilterList = [];
        this.ComponentAllList = [];
        this.ComponentList = [];
        this.ComponentFilterList = [];
        this.LineAllList = res.Line;
        this.LineList = res.Line;
        this.UnitAllList = res.Unit;
        this.AssemblyAllList = res.Assembly;
        this.SubAssemblyAllList = res.SubAssembly;
        this.ComponentAllList = res.Component;
        this.LineFilterList = this.LineList.slice();
        if (this.LineAllList && this.LineFilterList.length) {
          this.prevTask.line = this.LineList[0].PL_Id
            ? this.LineList[0].PL_Id
            : '';
        }
        this.setUnitList('notChange');
        this.setAssemblyList('notChange');
        this.setSubAssemblyList('notChange');
        this.setComponentList('notChange');
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  setUnitList(type: any) {
    this.UnitList = [];
    this.UnitFilterList = [];
    this.AssemblyList = [];
    this.AssemblyFilterList = [];
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];

    let unitList = this.UnitAllList.filter(
      (unit: any) => unit.PL_Id == this.prevTask.line
    );
    if (type == 'change') {
      this.prevTask.units = '';
      this.prevTask.assembly = '';
      this.prevTask.subAssembly = '';
      this.prevTask.component = '';
    } else if (type == 'edit') {
      this.UnitList = unitList;
      this.UnitFilterList = this.UnitList.slice();
      return;
    } else {
      if (unitList && unitList.length) {
        this.UnitList = unitList;
        this.UnitFilterList = this.UnitList.slice();
        this.prevTask.units = this.UnitFilterList[0].PU_Id
          ? this.UnitFilterList[0].PU_Id
          : '';
      }
    }
    if (unitList && unitList.length) {
      this.UnitList = unitList;
      this.UnitFilterList = this.UnitList.slice();
      this.prevTask.units = this.UnitFilterList[0].PU_Id
        ? this.UnitFilterList[0].PU_Id
        : '';
      if (type == 'change') {
        // this.prevTask.units = this.UnitFilterList[0].PU_Id
        //   ? this.UnitFilterList[0].PU_Id
        //   : '';
        this.setAssemblyList('change');
      }
    }
  }

  setAssemblyList(type: any) {
    this.AssemblyList = [];
    this.AssemblyFilterList = [];
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    if (type != 'edit') {
      this.prevTask.Checklist = [];
    }
    this.getAllQualityCheckListsNamesPreventiveMiantenance(this.prevTask.units);
    let assemblyList = this.AssemblyAllList.filter(
      (assembly: any) => assembly.PU_Id == this.prevTask.units
    );
    if (type == 'change') {
      this.prevTask.assembly = '';
      this.prevTask.subAssembly = '';
      this.prevTask.component = '';
    } else if (type == 'edit') {
      this.AssemblyList = assemblyList;
      this.AssemblyFilterList = this.AssemblyList.slice();
      return;
    } else {
      if (assemblyList && assemblyList.length) {
        this.AssemblyList = assemblyList;
        this.AssemblyFilterList = this.AssemblyList.slice();
        this.prevTask.assembly = this.AssemblyList[0].Assbly_Id
          ? this.AssemblyFilterList[0].Assbly_Id
          : '';
      }
    }

    if (assemblyList && assemblyList.length) {
      this.AssemblyList = assemblyList;
      this.AssemblyFilterList = this.AssemblyList.slice();
      if (type == 'change' && assemblyList.length == 1) {
        this.prevTask.assembly = this.AssemblyList[0].Assbly_Id
          ? this.AssemblyFilterList[0].Assbly_Id
          : '';
        this.setSubAssemblyList('change');
      }
    }
  }

  setSubAssemblyList(type: any) {
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let subassemblyList = this.SubAssemblyAllList.filter(
      (subassembly: any) => subassembly.Assbly_Id == this.prevTask.assembly
    );
    if (type == 'change') {
      this.prevTask.subAssembly = '';
      this.prevTask.component = '';
    } else if (type == 'edit') {
      this.SubAssemblyList = subassemblyList;
      this.SubAssemblyFilterList = this.SubAssemblyList.slice();
      return;
    } else {
      if (subassemblyList && subassemblyList.length) {
        this.SubAssemblyList = subassemblyList;
        this.SubAssemblyFilterList = this.SubAssemblyList.slice();
        this.prevTask.subAssembly = this.SubAssemblyList[0].SAssbly_Id
          ? this.SubAssemblyList[0].SAssbly_Id
          : '';
      }
    }

    if (subassemblyList && subassemblyList.length) {
      this.SubAssemblyList = subassemblyList;
      this.SubAssemblyFilterList = this.SubAssemblyList.slice();
      if (type == 'change' && subassemblyList.length == 1) {
        this.prevTask.subAssembly = this.SubAssemblyList[0].SAssbly_Id
          ? this.SubAssemblyList[0].SAssbly_Id
          : '';
        this.setComponentList('change');
      }
    } else {
    }
  }

  setComponentList(type: any) {
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let componentList = this.ComponentAllList.filter(
      (component: any) => component.SAssbly_Id == this.prevTask.subAssembly
    );
    if (type == 'change') {
      this.prevTask.component = '';
      if (componentList && componentList.length)
        this.prevTask.component = componentList[0].ComponentId
          ? componentList[0].ComponentId
          : '';
    } else if (type == 'edit') {
      this.ComponentList = componentList;
      this.ComponentFilterList = this.ComponentList.slice();
      return;
    } else {
      if (componentList && componentList.length) {
        this.ComponentList = componentList;
        this.ComponentFilterList = this.ComponentList.slice();
        this.prevTask.component = this.ComponentList[0].ComponentId
          ? this.ComponentList[0].ComponentId
          : '';
      }
    }

    if (componentList && componentList.length) {
      this.ComponentList = componentList;
      this.ComponentFilterList = this.ComponentList.slice();
      if (type == 'change' && componentList.length == 1) {
        this.prevTask.component = this.ComponentList[0].ComponentId
          ? this.ComponentList[0].ComponentId
          : '';
      }
    } else {
    }
  }

  onGroupKey(value: any) {
    this.GroupList = this.searchGroupKey(value.value);
  }

  searchGroupKey(value: string) {
    let filter = value;
    return this.GroupTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  onPlantKey(value: any) {
    this.PlantList = this.searchPlantKey(value.value);
  }

  searchPlantKey(value: string) {
    let filter = value;
    return this.PlantTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  // __________________________________________________________________________
  pmChange(opened: boolean): void {
    this.opentype = opened ? 'opened' : 'closed';

    this.getUserList();
  }
  // __________________________________________________________________________
  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.orgUserList = res;
        this.raci = this.orgUserList.slice();
        this.filteredUsers = this.orgUserList.slice();

        if (this.opentype == 'closed') {
          this.spinner.hide();
        } else if (this.opentype == 'opened') {
          this.spinner.hide();
        } else {
          this.getAllTechnician();
          this.getTask();
        }
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  // __________________________________________________________________________
  getTool() {
    this.spinnerText = 'Fetching Tool Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.PrevConfigurationService.getTool(data).subscribe(
      (res: any) => {
        this.AllTool = res.allToolList;
        this.ToolList = res.toolList;
        this.ExportTool = [];
        if (this.ToolList && this.ToolList.length) {
          for (const tool of this.ToolList) {
            // let grpObj = this.GroupList.find(
            //   (grp: any) => grp.id == tool.Group.egId
            // );
            // tool.Group = grpObj;
            // let pntObj = this.PlantList.find(
            //   (pnt: any) => pnt.id == tool.Plant.ptId
            // );
            // tool.Plant = pntObj;
            const ExportData = {
              ['Group']: tool.Group.egDesc,
              ['Plant']: tool.Plant.ptDesc,
              ['Tool Name']: tool.Name,
            };
            this.ExportTool.push(ExportData);
          }
        }
        this.ToolDataSource = new MatTableDataSource(this.ToolList);
        this.ToolPage.length = this.ToolList.length;
        this.getPaginator(this.ToolDataSource, 1);
        if (!this.isInit) this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  // __________________________________________________________________________
  getFrequency() {
    this.spinnerText = 'Fetching Frequency Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.PrevConfigurationService.getPrevFrequency(data).subscribe(
      (res: any) => {
        this.AllFrequency = res.allFrequencyList;
        this.frequencyList = res.frequencyList;
        this.filterFrequencyList =
          this.frequencyList && this.frequencyList.length
            ? this.frequencyList.slice()
            : [];
        this.ExportFrequency = [];
        if (this.frequencyList && this.frequencyList.length) {
          this.prevTask.Frequency = this.filterFrequencyList[0].ID
            ? this.filterFrequencyList[0].ID
            : '';
          this.FreqDuration = this.filterFrequencyList[0].Duration
            ? this.filterFrequencyList[0].Duration
            : 0;
          for (const fre of this.frequencyList) {
            // let grpObj = this.GroupList.find(
            //   (grp: any) => grp.id == fre.Group.egId
            // );
            // fre.Group = grpObj;
            // let pntObj = this.PlantList.find(
            //   (pnt: any) => pnt.id == fre.Plant.ptId
            // );
            // fre.Plant = pntObj;
            const ExportData = {
              ['Group']: fre.Group.egDesc,
              ['Plant']: fre.Plant.ptDesc,
              ['Frequency Name']: fre.Name,
              ['Duration / days']: fre.Duration,
            };
            this.ExportFrequency.push(ExportData);
          }
        }
        this.FrequencyDataSource = new MatTableDataSource(this.frequencyList);
        this.FrequencyPage.length = this.frequencyList.length;
        this.getPaginator(this.FrequencyDataSource, 2);
        if (!this.isInit) this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  // __________________________________________________________________________
  getTaskType() {
    this.spinnerText = 'Fetching TaskType Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.PrevConfigurationService.getTaskType(data).subscribe(
      (res: any) => {
        this.AllTaskType = res.allTaskTypeList;
        this.TaskTypeList = res.taskTypeList;
        this.filterTaskTypeList =
          this.TaskTypeList && this.TaskTypeList.length
            ? this.TaskTypeList.slice()
            : [];
        this.ExportTaskType = [];
        if (this.TaskTypeList && this.TaskTypeList.length) {
          this.prevTask.TaskType = this.filterTaskTypeList[0].ID
            ? this.filterTaskTypeList[0].ID
            : '';
          this.setMaintenanceType();
          for (const tasktype of this.TaskTypeList) {
            // let grpObj = this.GroupList.find(
            //   (grp: any) => grp.id == tasktype.Group.egId
            // );
            // tasktype.Group = grpObj;
            // let pntObj = this.PlantList.find(
            //   (pnt: any) => pnt.id == tasktype.Plant.ptId
            // );
            // tasktype.Plant = pntObj;
            const ExportData = {
              ['Group']: tasktype.Group.egDesc,
              ['Plant']: tasktype.Plant.ptDesc,
              ['Task Type Name']: tasktype.Name,
              ['Maintenance Type']: tasktype.MaintenanceType,
            };
            this.ExportTaskType.push(ExportData);
          }
        }
        this.TaskTypeDataSource = new MatTableDataSource(this.TaskTypeList);
        this.TaskTypePage.length = this.TaskTypeList.length;
        this.getPaginator(this.TaskTypeDataSource, 3);
        if (!this.isInit) this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  // __________________________________________________________________________
  getTask() {
    this.spinnerText = 'Fetching Frequency Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.PrevConfigurationService.getPrevTask(data).subscribe(
      (res: any) => {
        this.TaskList = res.taskList;
        this.ExportTask = [];
        if (this.TaskList && this.TaskList.length) {
          for (const task of this.TaskList) {
            if (task && task.Group) {
              task.Line = task && task.line ? task.line.plDesc : '';
              task.Unit = task && task.units ? task.units.puDesc : '';
              task.Assembly =
                task && task.assembly ? task.assembly.assblyDesc : '';
              task.SubAssembly =
                task && task.subAssembly ? task.subAssembly.sAsblyDesc : '';
              task.Component =
                task && task.component ? task.component.componentName : '';
              if (task) {
                const techIds =
                  task.Technician?.split(',').map((x) => x.trim()) || [];
                let techNames: string[] = [];

                if (task.TechnicianName) {
                  // Use names if available
                  const nameList = task.TechnicianName.split(',').map((x) =>
                    x.trim()
                  );
                  techNames = techIds.map((id, index) => nameList[index] || id); // fallback to ID if name missing
                } else {
                  // Lookup from filterTechnicianList
                  techNames = techIds.map((id) => {
                    const match = this.filterTechnicianList.find(
                      (t) => t.UserId === id
                    );
                    return match ? match.UserName : id; // fallback to ID if name not found
                  });
                }

                task.Technician = techNames.join(', ');
              }

              task.TaskType = task && task.TaskType ? task.TaskType.Name : '';
              task.TaskStatus = task && task.TaskStatus ? task.TaskStatus : '';
              task.WOType = task && task.WOType ? task.WOType.Name : '';
              task.Frequency =
                task && task.Frequency ? task.Frequency.Name : '';
              task.FromTaskDate = task && task.StartDate ? task.StartDate : '';
              task.ToTaskDate = task && task.ToTaskDate ? task.ToTaskDate : '';
              task.CreatedBy = this.setUserName(task.CreatedBy);
              task.IsWrite = this.isWrite;
              task.Status = task && task.InActive ? 'Active' : 'InActive';

              const ExportData = {
                ['Group']: task.Group.egDesc,
                ['Plant']: task.Plant.ptDesc,
                ['Line']: task.Line,
                ['Unit']: task.Unit,
                ['Assembly']: task.Assembly,
                ['SubAssembly']: task.SubAssembly,
                ['Component']: task.Component,
                ['Description']: task.Description,
                ['TaskStatus']: task.TaskStatus,
                ['Technician']:
                  task.Technician && task?.Technician && task.Technician
                    ? task.Technician
                    : '',

                ['Task Type']: task.TaskType ? task?.TaskType : '',
                ['Frequency']: task.Frequency ? task?.Frequency : '',
                ['Activity Type']: task.WOType ? task?.WOType : '',
                ['Duration / Min']: task.Duration,
                ['Spare Parts']: task.SpareParts,
                ['From Task Date']: task.FromTaskDate
                  ? moment(task.FromTaskDate).format('DD/MM/YYYY')
                  : '',
                ['To Task Date']: task.ToTaskDate
                  ? moment(task.ToTaskDate).format('DD/MM/YYYY')
                  : '',
              };

              this.ExportTask.push(ExportData);
            }
          }
        }
        this.TaskPage.length = res.allTaskList;
        setTimeout(() => {
          this.spinner.hide();
          this.isInit = false;
        }, 3000);
      },
      (err: any) => {
        setTimeout(() => {
          this.spinner.hide();
          this.isInit = false;
        }, 3000);
      }
    );
  }
  // __________________________________________________________________________
  getWOType() {
    this.spinnerText = 'Fetching WOType Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'PM',
    };
    this.RMConfigurationService.getWOType(data).subscribe(
      (res: any) => {
        if (!this.isInit) this.spinner.hide();
        this.AllWOType = res.allWoTypeList;
        this.WOTypeList = res.woTypeList;
        this.WOTypeFiltList =
          this.WOTypeList && this.WOTypeList.length
            ? this.WOTypeList.slice()
            : [];
        this.ExportWOType = [];
        if (this.WOTypeList && this.WOTypeList.length) {
          this.prevTask.WOType = this.WOTypeFiltList[0].ID
            ? this.WOTypeFiltList[0].ID
            : '';
          for (const wotype of this.WOTypeList) {
            // let grpObj = this.GroupList.find(
            //   (grp: any) => grp.id == wotype.Group.egId
            // );
            // wotype.Group = grpObj;
            // let pntObj = this.PlantList.find(
            //   (pnt: any) => pnt.id == wotype.Plant.ptId
            // );
            // wotype.Plant = pntObj;
            const ExportData = {
              ['Group']: wotype.Group.egDesc,
              ['Plant']: wotype.Plant.ptDesc,
              ['Activity Type Name']: wotype.Name,
            };
            this.ExportWOType.push(ExportData);
          }
        }
        this.WOTypeDataSource = new MatTableDataSource(this.WOTypeList);
        this.WOTypePage.length = this.WOTypeList.length;
        this.getPaginator(this.WOTypeDataSource, 0);
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }
  // ______________________________________________________________________________
  getAllTechnician() {
    this.spinnerText = 'Fetching Technician Data';
    this.spinner.show();
    const data = {
      Plant: this.plantSession?.plantCode,
      Group: this.groupSession?.groupCode,
      RMPM: 'PM',
    };
    this.RMConfigurationService.getTechnician(data).subscribe(
      (res: any) => {
        if (!this.isInit) this.spinner.hide();
        if (this.groupSession?.groupCode && this.plantSession?.plantCode) {
          this.TechnicianList = res.data;
          this.Technician.Name = [];
          // this.availableUsersList = this.orgUserList.filter((usr: any) => !res.occupiedTechnicians.includes(usr.UserId));
          this.userList = [...this.orgUserList];
          this.filterTechnicianList = [];
          for (let tech of this.TechnicianList) {
            const user = this.userList.find(
              (user: any) => user.employeeCode == tech.UserId
            );
            if (user) {
              tech.UserName = user.fullName;
              let check;
              if (this.Technician?.Name?.length) {
                check = this.Technician.Name.find(
                  (user: any) => user == tech.UserId
                );
                if (!check) {
                  this.Technician.Name.push(tech.UserId);
                  this.filterTechnicianList.push({
                    UserId: tech.UserId,
                    UserName: tech.UserName,
                  });
                }
              } else {
                this.Technician.Name.push(tech.UserId);
                this.filterTechnicianList.push({
                  UserId: tech.UserId,
                  UserName: tech.UserName,
                });
              }
            }
          }
          // for (let filtech of this.Technician.Name) {
          //   var obj = this.userList.find((user: any) => userSession?.userCode == filtech)
          //   if (obj)
          //     this.filterTechnicianList.push(obj);
          // }
        } else {
          for (let exceltech of res.occupiedTechnicians) {
            var usr = this.userList.find(
              (user: any) => user.employeeCode == exceltech
            );
            if (usr) this.ExcelTechnicianList.push(usr);
          }
        }
        this.TechnicianFiltList =
          this.filterTechnicianList && this.filterTechnicianList.length
            ? this.filterTechnicianList.slice()
            : [];

        // this.prevTask.Technician = this.TechnicianFiltList[0].UserId
        //   ? this.TechnicianFiltList[0].UserId
        //   : '';
        this.ExportTechnician = [];
        if (this.TechnicianList && this.TechnicianList.length) {
          for (const tech of this.TechnicianList) {
            const ExportData = {
              ['Group']: tech.Group.egDesc,
              ['Plant']: tech.Plant.ptDesc,
              ['Technician']: tech.UserName,
            };
            this.ExportTechnician.push(ExportData);
          }
        }
        if (this.Technician.Name.length == this.userList.length)
          this.TechnicianForm.controls.Name.patchValue([
            ...this.userList.map((item) => item.employeeCode),
            'ALL',
          ]);
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  // __________________________________________________________________________
  applyWOTypeFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.WOTypeDataSource.filter = filterValue.trim().toLowerCase();

    if (this.WOTypeDataSource.paginator) {
      this.WOTypeDataSource.paginator.firstPage();
    }
  }
  // __________________________________________________________________________
  applyToolFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.ToolDataSource.filter = filterValue.trim().toLowerCase();

    if (this.ToolDataSource.paginator) {
      this.ToolDataSource.paginator.firstPage();
    }
  }
  // __________________________________________________________________________
  applyFrequencyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.FrequencyDataSource.filter = filterValue.trim().toLowerCase();

    if (this.FrequencyDataSource.paginator) {
      this.FrequencyDataSource.paginator.firstPage();
    }
  }
  // __________________________________________________________________________
  applyTaskTypeFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.TaskTypeDataSource.filter = filterValue.trim().toLowerCase();

    if (this.TaskTypeDataSource.paginator) {
      this.TaskTypeDataSource.paginator.firstPage();
    }
  }
  // __________________________________________________________________________
  applyTaskFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.TaskDataSource.filter = filterValue.trim().toLowerCase();

    if (this.TaskDataSource.paginator) {
      this.TaskDataSource.paginator.firstPage();
    }
  }

  // ____________________________________________________________
  editWOType(element: any) {
    this.WOType.ID = element.ID;
    this.WOType.Name = element.Name;
    this.edited = true;
  }
  // ____________________________________________________________
  editTool(element: any) {
    this.edited = true;
    this.prevTool.ID = element.ID;
    this.prevTool.Name = element.Name;
  }
  // ____________________________________________________________
  editFrequency(element: any) {
    this.edited = true;
    this.prevFrequency.ID = element.ID;
    this.prevFrequency.Name = element.Name;
    this.prevFrequency.Duration = element.Duration;
  }
  // ____________________________________________________________
  editTaskType(element: any) {
    this.edited = true;
    this.prevTaskType.ID = element.ID;
    this.prevTaskType.Name = element.Name;
    this.prevTaskType.MaintenanceType = element.MaintenanceType;
  }

  // ____________________________________________________________
  editTaskRow(element: any) {
    if (this.permissionService.isUserHasPermission(this.isUpdate)) {
      this.existingTaskRow = element.rowData;
      if (
        element.rowData.FromTaskDate !== null &&
        element.rowData.FromTaskDate !== undefined &&
        element.rowData.FromTaskDate !== ''
      ) {
        this.prevTaskForm
          .get('fromTaskDate')
          ?.setValue(element.rowData.FromTaskDate);
        this.prevTaskForm
          .get('toTaskDate')
          ?.setValue(element.rowData.ToTaskDate);
      }
      this.InActiveValidation = true;

      const checklistIdsStr = element.rowData?.ChecklistIds || '';
      const checklistIds = checklistIdsStr
        .split(',')
        .map((id) => Number(id.trim()))
        .filter((id) => !isNaN(id));
      this.prevTask.Checklist =
        this.checklists.length == checklistIds.length
          ? ['ALL', ...checklistIds]
          : [...checklistIds];

      element = element.rowData;
      this.edited = true;
      this.disableFrq = true;
      let UploadFiles: any = [];
      let UploadFilesType: any = [];
      this.FileData = [];
      this.FileList = [];
      this.EditFileData = [];

      this.prevTask.ID = element.ID;
      this.prevTask.Description = element.Description;
      // this.prevTask.TechnicianDept = element.TechnicianDept;
      this.prevTask.Duration = element.Duration;
      this.prevTask.SpareParts = element.SpareParts;
      this.prevTask.MaintenanceType = element.MaintenanceType;
      this.editMaintenanceType = element.MaintenanceType;

      const technicianNames =
        element.Technician?.split(',').map((name) =>
          name.trim().toLowerCase()
        ) || [];

      const matchedUserIds = technicianNames.map((name) => {
        const match = this.TechnicianFiltList.find(
          (tec: any) => tec.UserName.trim().toLowerCase() === name
        );
        return match ? match.UserId : name; // fallback to name if not found
      });

      this.prevTask.Technician = matchedUserIds;
      const freqObj = this.filterFrequencyList.find(
        (fre: any) =>
          fre.Name.trim().toLowerCase() ==
          element.Frequency.trim().toLowerCase()
      );
      const wotObj = this.WOTypeFiltList.find(
        (wo: any) =>
          wo.Name.trim().toLowerCase() == element.WOType.trim().toLowerCase()
      );
      const ttObj = this.filterTaskTypeList.find(
        (tt: any) =>
          tt.Name.trim().toLowerCase() == element.TaskType.trim().toLowerCase()
      );
      this.prevTask.Frequency = freqObj ? freqObj.ID : '';
      this.prevTask.WOType = wotObj ? wotObj.ID : '';
      this.prevTask.TaskType = ttObj ? ttObj.ID : '';
      this.editTaskTypeID = ttObj ? ttObj.ID : '';
      this.prevTask.TechnicianRole = element.TechnicianRole
        ? element.TechnicianRole
        : '';
      if (element.UploadFile && element.FileType) {
        UploadFiles = element.UploadFile.split(',');
        UploadFilesType = element.FileType.split(',');
        for (let i = 0; i < UploadFiles.length; i++) {
          const fileName = UploadFiles[i].trim();
          const fileExtension = fileName
            .substring(fileName.lastIndexOf('.') + 1)
            .toLowerCase();
          this.EditFileData.push({
            FileType: UploadFilesType[i],
            ImageSrc: UploadFiles[i],
            FileExtension: fileExtension,
          });
        }
      }

      if (element.units) {
        this.prevTask.displayMachine =
          element.line.plDesc + '/' + element.units.puDesc;
        this.prevTask.line = element.line.plId;
        this.prevTask.units = element.units.puId;
        if (element.assembly) {
          this.prevTask.displayMachine =
            element.line.plDesc +
            '/' +
            element.units.puDesc +
            '/' +
            element.assembly.assblyDesc;
          this.prevTask.assembly = element.assembly.assblyId;
          if (element.subAssembly) {
            this.prevTask.displayMachine =
              element.line.plDesc +
              '/' +
              element.units.puDesc +
              '/' +
              element.assembly.assblyDesc +
              '/' +
              element.subAssembly.sAsblyDesc;
            this.prevTask.subAssembly = element.subAssembly.sAssblyId;
            if (element.component) {
              this.prevTask.displayMachine =
                element.line.plDesc +
                '/' +
                element.units.puDesc +
                '/' +
                element.assembly.assblyDesc +
                '/' +
                element.subAssembly.sAsblyDesc +
                '/' +
                element.component.componentName;
              this.prevTask.component = element.component.componentId;
            }
          }
        }
      }

      const obj = this.frequencyList.find(
        (freq: any) => freq.ID == this.prevTask.Frequency
      );
      this.FreqDuration = obj.Duration;

      this.isImageFile = false;
      this.isVideoFile = false;
      this.imageSrc = [];
      // this.prevTask.FromTaskDate = element.CreatedAt;
      this.prevTask.FromTaskDate = element.StartDate;
      this.prevTask.ToTaskDate = element.ToTaskDate;
      this.minDate = element.StartDate;
      this.toTaskMinDate = this.prevTask.ToTaskDate;
      const fromTaskDate =
        this.prevTask.FromTaskDate !== ''
          ? new Date(this.prevTask.ToTaskDate)
          : null;
      const toTaskDate =
        this.prevTask.ToTaskDate !== ''
          ? new Date(this.prevTask.ToTaskDate)
          : null;
      const currentDate = new Date();
      if (
        toTaskDate < currentDate ||
        toTaskDate === null ||
        toTaskDate === undefined
      )
        this.disableToTaskDate = true;
      else this.disableToTaskDate = false;

      this.setUnitList('edit');
      this.setAssemblyList('edit');
      this.setSubAssemblyList('edit');
      this.setComponentList('edit');

      // this.prevTaskForm.get('line')?.setValue(element.line.plId);
      // this.prevTaskForm.get('unit')?.setValue(element.units.puId);
      // this.prevTaskForm.get('assembly')?.setValue(element.assembly.assblyId);
      // this.prevTaskForm.get('subAssembly')?.setValue(element.subAssembly.sAssblyId);
      // this.prevTaskForm.get('component')?.setValue(element.component.componentId);
    }
  }
  onDropdownOpened(opened: boolean, type: string): void {
    if (opened) return;

    switch (type) {
      case 'Line':
        this.LineFilterList = [...this.LineList];
        break;
      case 'Unit':
        this.UnitFilterList = [...this.UnitList];
        break;
      case 'Assembly':
        this.AssemblyFilterList = [...this.AssemblyList];
        break;
      case 'subAssembly':
        this.SubAssemblyFilterList = [...this.SubAssemblyList];
        break;
      case 'Component':
        this.ComponentFilterList = [...this.ComponentList];
        break;
      case 'checklist':
        this.checklists = [...this.checklists];
        break;
      case 'WOType':
        this.WOTypeFiltList = [...this.WOTypeList];
        break;
      case 'frequency':
        this.filterFrequencyList = [...this.frequencyList];
        break;
      case 'task_type':
        this.filterTaskTypeList = [...this.TaskTypeList];
        break;
      case 'TechnicianRole':
        this.filterRoles = [...this.plantRoles];
        break;
      case 'technicians':
        this.TechnicianFiltList = [...this.filterTechnicianList];
        break;
      // Add more cases as needed
      default:
        console.warn('Unknown dropdown type:', type);
    }
  }
  onTechnicianFiltered(filteredList: any[]): void {
    const selectedIds = Array.isArray(this.prevTask.Technician) ? this.prevTask.Technician : [];
    const selectedTechnicians = this.filterTechnicianList.filter(tech => 
      selectedIds.includes(tech.UserId)
    ); 
    const uniqueTechnicians = [...filteredList];  
    selectedTechnicians.forEach(selectedTech => {
      if (!uniqueTechnicians.find(tech => tech.UserId === selectedTech.UserId)) {
        uniqueTechnicians.unshift(selectedTech); 
      }
    });
    this.TechnicianFiltList = uniqueTechnicians;
  }
  
  // __________________________________________________________________
  deleteTool(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete Tool!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        const data = {
          ID: element.ID,
        };
        this.PrevConfigurationService.deleteTool(data).subscribe(
          (success) => {
            this.toaster.success(`Data Deleted Successfully`, 'Success', {
              timeOut: 3000,
            });

            if (success.status == true) {
              this.toaster.success(success.message, 'Success', {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, 'Warning', {
                timeOut: 3000,
              });
            }

            this.spinner.hide();
            this.getTool();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error('Error', error.error.message);
          }
        );
      }
      this.edited = false;
    });
  }
  // __________________________________________________________________
  delFrequency(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete Frequency!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        const data = {
          ID: element.ID,
        };
        this.PrevConfigurationService.deletePrevFrequency(data).subscribe(
          (success) => {
            if (success.status == true) {
              this.toaster.success(success.message, 'Success', {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, 'Warning', {
                timeOut: 3000,
              });
            }
            this.spinner.hide();
            this.getFrequency();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error('Error', error.error.message);
          }
        );
      }
      this.edited = false;
    });
  }
  // __________________________________________________________________
  deleteWOType(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete WOType!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.RMConfigurationService.deleteWOType(element).subscribe(
          (success) => {
            if (success.status == true) {
              this.toaster.success(success.message, 'Success', {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, 'Warning', {
                timeOut: 3000,
              });
            }
            this.spinner.hide();
            this.getWOType();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error('Error', error.error.message);
          }
        );
      }
      this.edited = false;
    });
  }
  // __________________________________________________________________
  deleteTaskType(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete Task Type!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        const data = {
          ID: element.ID,
        };
        this.PrevConfigurationService.deleteTaskType(data).subscribe(
          (success) => {
            this.spinner.hide();
            if (success.status == true) {
              this.toaster.success(success.message, 'Success', {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, 'Warning', {
                timeOut: 3000,
              });
            }

            this.getTaskType();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error('Error', error.error.message);
          }
        );
      }
      this.edited = false;
    });
  }
  // __________________________________________________________________
  deleteTaskRow(element: any) {
    if (this.permissionService.isUserHasPermission(this.isDelete)) {
      element = element.rowData;
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete Task!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.spinner.show();
          const data = {
            ID: element.ID,
          };
          this.PrevConfigurationService.deletePrevTask(data).subscribe(
            (success) => {
              if (success.status == true) {
                this.toaster.success(success.message, 'Success', {
                  timeOut: 3000,
                });
              } else {
                this.toaster.warning(success.message, 'Warning', {
                  timeOut: 3000,
                });
              }
              this.spinner.hide();
              this.getTask();
            },
            (error) => {
              this.spinner.hide();
              this.toaster.error('Error', error.error.message);
            }
          );
        }
        this.edited = false;
      });
    }
  }

  // ______________________________________________________________________
  WOTypeSubmit(formDirective: FormGroupDirective) {
    if (this.WOTypeForm.status == 'INVALID') {
      this.toaster.warning('Warning', 'Please Fill All Required Fields');
      this.spinner.hide();
      return;
    } else {
      this.spinner.show();
      this.formDirective = formDirective;
      this.WOType.CreatedAt = new Date();
      this.WOType.CreatedBy = this.userSession?.userCode;
      this.WOType.RMPM = 'PM';
      const headerData = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.WOType,
        HeaderData: headerData,
      };
      if (!this.edited) {
        const chkWOType = this.WOTypeList.find((wo: any) => {
          const a = wo.Name.toLowerCase();
          const b = this.WOType.Name.toLowerCase();
          return a == b;
        });
        if (chkWOType) {
          this.toaster.warning('Warning', 'This WOType Already Exist');
          this.spinner.hide();
          return;
        }
        this.RMConfigurationService.addWOType(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.WOTypeForm.reset();
            this.edited = false;
            if (res.status) {
              this.toaster.success('Date Added Successfully', res.message);
              this.formDirective.resetForm();
              this.WOTypeForm.reset();
              this.getWOType();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      } else {
        const chkWOType = this.WOTypeList.find((wo: any) => {
          const a = wo.Name.toLowerCase();
          const b = this.WOType.Name.toLowerCase();
          this.spinner.hide();

          return a == b;
        });
        if (chkWOType) {
          this.toaster.warning('Warning', 'This WOType Already Exist');
          this.spinner.hide();
          return;
        }
        this.RMConfigurationService.updateWOType(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.WOTypeForm.reset();
            this.edited = false;
            if (res.status) {
              this.toaster.success('Date Updated Successfully', res.message);
              this.formDirective.resetForm();
              this.WOTypeForm.reset();
              this.getWOType();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }
  // ______________________________________________________________________
  ToolOnSubmit(formDirective: FormGroupDirective) {
    if (this.HeaderForm.invalid) {
      this.toaster.warning('Warning', 'Please Fill Header Fields');
      return;
    } else if (this.prevToolForm.invalid) {
      this.toaster.warning('Warning', 'Please Fill All Required Fields');
      return;
    } else {
      this.formDirective = formDirective;
      this.prevTool.CreatedAt = new Date();
      this.prevTool.CreatedBy = this.userSession?.userCode;
      const headerData = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.prevTool,
        HeaderData: headerData,
      };
      if (!this.edited) {
        const chkTool = this.ToolList.find((tool: any) => {
          const a = tool.Name.toLowerCase();
          const b = this.prevTool.Name.toLowerCase();
          return a == b;
        });
        if (chkTool) {
          this.toaster.warning('Warning', 'This Tool Already Exist');
          return;
        }
        this.PrevConfigurationService.addTool(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            this.formDirective.resetForm();
            this.prevToolForm.reset();
            if (res.status) {
              this.toaster.success('Date Added Successfully', res.message);
              this.getTool();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      } else {
        this.PrevConfigurationService.updateTool(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            this.formDirective.resetForm();
            this.prevToolForm.reset();
            if (res.status) {
              this.toaster.success('Date Updated Successfully', res.message);
              this.getTool();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }
  // ______________________________________________________________________
  FrequencyOnSubmit(formDirective: FormGroupDirective) {
    if (this.prevFrequencyForm.invalid) {
      this.spinner.hide();
      this.toaster.warning('Warning', 'Please Fill All Required Fields');
      return;
    } else {
      this.spinner.show();
      this.formDirective = formDirective;
      this.prevFrequency.CreatedAt = new Date();
      this.prevFrequency.CreatedBy = this.userSession?.userCode;
      const headerData = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.prevFrequency,
        HeaderData: headerData,
      };
      if (!this.edited) {
        const chkFrequency = this.frequencyList.find((fre: any) => {
          const a = fre.Name.toLowerCase();
          const b = this.prevFrequency.Name.toLowerCase();
          return a == b;
        });
        if (chkFrequency) {
          this.toaster.warning('Warning', 'This Frequency Already Exist');
          this.spinner.hide();
          return;
        }
        this.PrevConfigurationService.addPrevFrequency(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            if (res.status) {
              this.toaster.success('Date Added Successfully', res.message);
              this.formDirective.resetForm();
              this.prevFrequencyForm.reset();
              this.getFrequency();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      } else {
        const chkFrequency = this.frequencyList.find((fre: any) => {
          const a = fre.Name.toLowerCase();
          const b = this.prevFrequency.Name.toLowerCase();
          return a == b;
        });
        if (chkFrequency) {
          this.toaster.warning('Warning', 'This Frequency Already Exist');
          this.spinner.hide();
          return;
        }
        this.PrevConfigurationService.updatePrevFrequency(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            if (res.status) {
              this.toaster.success('Date Updated Successfully', res.message);
              this.formDirective.resetForm();
              this.prevFrequencyForm.reset();
              this.getFrequency();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }
  // ______________________________________________________________________
  TaskTypeOnSubmit(formDirective: FormGroupDirective) {
    if (this.prevTaskTypeForm.invalid) {
      this.spinner.hide();
      this.toaster.warning('Warning', 'Please Fill All Required Fields');
      return;
    } else {
      this.spinner.show();
      this.formDirective = formDirective;
      this.prevTaskType.CreatedAt = new Date();
      this.prevTaskType.CreatedBy = this.userSession?.userCode;
      const headerData = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.prevTaskType,
        HeaderData: headerData,
      };
      if (!this.edited) {
        const chkTaskType = this.TaskTypeList.find((tasktype: any) => {
          const a = tasktype.Name.toLowerCase();
          const b = this.prevTaskType.Name.toLowerCase();
          const c = tasktype?.MaintenanceType?.toLowerCase();
          const d = this.prevTaskType?.MaintenanceType?.toLowerCase();
          return a == b && c == d;
        });
        if (chkTaskType) {
          this.toaster.warning('Warning', 'This TaskType Already Exist');
          this.spinner.hide();
          return;
        }
        this.PrevConfigurationService.addTaskType(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            this.formDirective.resetForm();
            this.prevTaskTypeForm.reset();
            if (res.status) {
              this.toaster.success('Date Added Successfully', res.message);
              this.getTaskType();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      } else {
        const chkTaskType = this.TaskTypeList.find((tasktype: any) => {
          const a = tasktype.Name.toLowerCase();
          const b = this.prevTaskType.Name.toLowerCase();
          const c = tasktype?.MaintenanceType?.toLowerCase();
          const d = this.prevTaskType?.MaintenanceType?.toLowerCase();
          return a == b && c == d;
        });
        if (chkTaskType) {
          this.toaster.warning('Warning', 'This TaskType Already Exist');
          this.spinner.hide();
          return;
        }
        this.PrevConfigurationService.updateTaskType(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            this.formDirective.resetForm();
            this.prevTaskTypeForm.reset();
            if (res.status) {
              this.toaster.success('Date Updated Successfully', res.message);
              this.getTaskType();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }
  // __________________________________________________________________
  cellClicked(params: any): void {
    const col = params.colDef.field;
    if (
      params.data?.Status === 'Active' &&
      this.filteredRowsData?.length === 0
    ) {
      this.Active = true;
    } else if (
      params.data?.Status === 'InActive' &&
      (this.filteredRowsData?.length === 0 ||
        this.filteredRowsData === undefined)
    ) {
      this.Active = false;
    }
  }

  dateChange() {
    const fromTaskDate = this.prevTaskForm.get('fromTaskDate')?.value;
    const toTaskDate = this.prevTaskForm.get('toTaskDate')?.value;
    if (fromTaskDate?._d) {
      if (fromTaskDate && toTaskDate && fromTaskDate > toTaskDate) {
        this.toaster.warning(
          'To Task Date must be greater than or equal to From Task Date'
        );
        this.prevTaskForm.get('toTaskDate').reset();
        setTimeout(() => {
          this.prevTask.ToTaskDate = '';
        }, 500);
      }
    }
    // const formattedDate = toTaskDate.format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }

  // dateChange() {
  //   const fromTaskDate = this.prevTaskForm.get('fromTaskDate')?.value;
  //   const toTaskDate = this.prevTaskForm.get('toTaskDate')?.value;

  //   // Extract date part only
  //   const fromDate = fromTaskDate ? new Date(fromTaskDate._i).setHours(0, 0, 0, 0) : null;
  //   const toDate = toTaskDate ? new Date(toTaskDate._i).setHours(0, 0, 0, 0) : null;

  //   if (fromDate && toDate && fromDate > toDate) {
  //     this.toaster.warning('To Task Date must be greater than or equal to From Task Date');
  //     this.prevTaskForm.get('toTaskDate').reset();
  //   }
  // }

  TaskOnSubmit(formDirective: FormGroupDirective) {
    if (this.InActiveValidation) {
      if (this.prevTaskForm.invalid) {
        this.toaster.warning('Warning', 'Please Fill All Required Fields');
        return;
      } else {
        this.formDirective = formDirective;
        this.prevTask.Group = this.groupSession?.groupCode;
        this.prevTask.Plant = this.plantSession?.plantCode;
        this.prevTask.CreatedAt = new Date();
        this.prevTask.CreatedBy = this.userSession?.userCode;
        let NextDate = new Date();
        NextDate.setDate(NextDate.getDate() + this.FreqDuration);
        this.prevTask.NextScheduleAt = NextDate;
        this.prevTask.NextScheduleAt = this.prevTask.NextScheduleAt;

        this.prevTask.FromTaskDate =
          this.prevTask.FromTaskDate && this.prevTask.FromTaskDate !== ''
            ? moment(new Date(this.prevTask.FromTaskDate)).format(
              'MM/DD/YYYY hh:mm:ss'
            )
            : null;

        this.prevTask.ToTaskDate =
          this.prevTask.ToTaskDate && this.prevTask.ToTaskDate !== ''
            ? moment(new Date(this.prevTask.ToTaskDate)).format(
              'MM/DD/YYYY hh:mm:ss'
            )
            : null;

        if (!this.prevTask.assembly) this.prevTask.assembly = null;
        if (!this.prevTask.subAssembly) this.prevTask.subAssembly = null;
        if (!this.prevTask.component) this.prevTask.component = null;
        this.prevTask.Checklist = this.prevTask.Checklist
          ? this.prevTask.Checklist.filter((item) => item !== 'ALL').join(',')
          : '';
        this.prevTask.Technician = this.prevTask.Technician && Array.isArray(this.prevTask.Technician)
          ? this.prevTask.Technician.join(',')
          : null;
        this.spinner.show();
        if (!this.edited) {
          this.spinnerText = 'Creating Prev Task Data';
          const duplicateTask = this.TaskList.find(
            (task: any) =>
              (task.Description ?? '').toString().trim().toLowerCase() ===
              (this.prevTask.Description ?? '')
                .toString()
                .trim()
                .toLowerCase() &&
              (task.subAssembly.sAssblyId ?? '')
                .toString()
                .trim()
                .toLowerCase() ===
              (this.prevTask.subAssembly ?? '')
                .toString()
                .trim()
                .toLowerCase()
          );

          if (duplicateTask) {
            this.spinner.hide();
            this.toaster.error(
              'Duplicate record found with same Description and Sub-Assembly.',
              'Error',
              {
                timeOut: 3000,
              }
            );
            return;
          }
          const Formvalues = new FormData();
          for (const file of this.FileList)
            Formvalues.append('File', file, file.name);
          Formvalues.append('Data', JSON.stringify(this.prevTask));
          // Formvalues.append('Checklist', JSON.stringify(this.checklistTempData));
          this.PrevConfigurationService.addPrevTask(Formvalues).subscribe(
            (res: any) => {
              if (res.status) {
                this.prevTask = {
                  line: null,
                  units: null,
                  assembly: null,
                  subAssembly: null,
                  component: null,
                  lineName: '',
                  unitName: '',
                  assemblyName: '',
                  subAssemblyName: '',
                  componentName: '',
                  Description: '',
                  Technician: '',
                  Frequency: '',
                  displayMachine: '',
                  Duration: '',
                  SpareParts: '',
                  UploadFile: '',
                  TaskType: '',
                  TechnicianRole: '',
                  MaintenanceType: '',
                  FromTaskDate: new Date(),
                  FileType: [],
                  CreatedAt: '',
                  CreatedBy: 0,
                  ID: 0,
                  Checklist: '',
                };
                this.FileData = [];
                this.FileList = [];
                this.minDate = new Date();
                this.toTaskMinDate = new Date();
                this.spinner.hide();
                this.toaster.success(
                  res.message || `Data Inserted Successfully`,
                  'Success',
                  {
                    timeOut: 3000,
                  }
                );
                this.edited = false;
                this.formDirective.resetForm();
                this.prevTaskForm.reset();
                this.getTask();
              }
            },
            (err: any) => {
              this.spinner.hide();
              this.toaster.error(err.message || `Server Error`, 'Error', {
                timeOut: 3000,
              });
            }
          );
        } else {
          this.spinnerText = 'Updating Prev Task Data';
          delete this.prevTask.lineName;
          delete this.prevTask.unitName;
          delete this.prevTask.assemblyName;
          delete this.prevTask.subAssemblyName;
          delete this.prevTask.componentName;
          delete this.prevTask.displayMachine;

          if (this.EditFileData.length) {
            let lastFiles = '';
            for (var i = 0; i < this.EditFileData.length; i++) {
              if (lastFiles != '') {
                lastFiles = lastFiles + ',' + this.EditFileData[i].ImageSrc;
              } else {
                lastFiles = this.EditFileData[i].ImageSrc;
              }
            }
            this.prevTask.UploadFile = lastFiles;
          }
          const Formvalues = new FormData();
          for (const file of this.FileList)
            Formvalues.append('File', file, file.name);
          Formvalues.append('Data', JSON.stringify(this.prevTask));
          this.PrevConfigurationService.updatePrevTask(Formvalues).subscribe(
            (res: any) => {
              if (res.status) {
                this.spinner.hide();
                this.FileList = [];
                this.FileData = [];
                this.EditFileData = [];
                this.toaster.success(
                  res.message || `Data Updated Successfully`,
                  'Success',
                  {
                    timeOut: 3000,
                  }
                );
                this.minDate = new Date();
                this.edited = false;
                this.prevTask = {
                  line: null,
                  units: null,
                  assembly: null,
                  subAssembly: null,
                  component: null,
                  lineName: '',
                  unitName: '',
                  assemblyName: '',
                  subAssemblyName: '',
                  componentName: '',
                  Description: '',
                  Technician: '',
                  Frequency: '',
                  displayMachine: '',
                  Duration: '',
                  SpareParts: '',
                  UploadFile: '',
                  TaskType: '',
                  TechnicianRole: '',
                  MaintenanceType: '',
                  FromTaskDate: new Date(),
                  FileType: [],
                  CreatedAt: '',
                  CreatedBy: 0,
                  ID: 0,
                  Checklist: '',
                };
                this.formDirective.resetForm();
                this.prevTaskForm.reset();
                this.minDate = new Date();
                this.toTaskMinDate = new Date();
                ``;
                this.getTask();
              }
            },
            (err: any) => {
              this.spinner.hide();
              this.toaster.error(err.message || `Server Error`, 'Error', {
                timeOut: 3000,
              });
            }
          );
        }
      }
    } else {
      this.InActiveValidation = true;
    }
  }
  TechnicianSubmit() {
    const index: number = this.Technician.Name.indexOf('ALL');
    if (index !== -1) {
      this.Technician.Name.splice(index, 1);
    }
    this.Technician.CreatedAt = new Date();
    this.Technician.CreatedBy = this.userSession?.userCode;
    const headerData = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    const data = {
      Data: this.Technician,
      HeaderData: headerData,
    };
    if (this.Technician.Name.length == 0) {
      this.toaster.warning('Select Atleast one technician', 'Warning');
      return;
    }
    this.RMConfigurationService.addTechnician(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success(res.message, 'Success');
          this.getAllTechnician();
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message, 'Error');
      }
    );
  }

  searchValues(filter: any) {
    filter = filter.target.value;
    this.userList = this.orgUserList.filter((user: any) => {
      let lowerCase = user.fullName.toLocaleLowerCase();
      return (
        user.fullName.startsWith(filter) || lowerCase.startsWith(filter) !== 0
      );
    });
  }
  setUserName(val: any) {
    if (this.userList && this.userList.length) {
      const CreatedBy = this.userList.find((usr: any) => usr.UserId == val);
      return CreatedBy ? CreatedBy.fullName : '';
    }
  }

  customePaginator(event: any, name: any) {
    if (name == 'activitytype') {
      this.WOTypePage.pageIndex = event.pageIndex;
      this.WOTypePage.pageSize = event.pageSize;
    } else if (name == 'tool') {
      this.ToolPage.pageIndex = event.pageIndex;
      this.ToolPage.pageSize = event.pageSize;
    } else if (name == 'frequency') {
      this.FrequencyPage.pageIndex = event.pageIndex;
      this.FrequencyPage.pageSize = event.pageSize;
    } else if (name == 'tasktype') {
      this.TaskTypePage.pageIndex = event.pageIndex;
      this.TaskTypePage.pageSize = event.pageSize;
    } else if (name == 'task') {
      this.TaskPage.pageIndex = event.pageIndex;
      this.TaskPage.pageSize = event.pageSize;
      this.getTask();
    }
  }

  onNodeSelect(node: any): void {
    this.updateOrderprocessingData = false;
    if (
      node.Level == 'Unit' ||
      node.Level == 'Assembly' ||
      node.Level == 'SubAssembly' ||
      node.Level == 'Component'
    ) {
      this.prevTask.line = null;
      this.prevTask.units = null;
      this.prevTask.assembly = null;
      this.prevTask.subAssembly = null;
      this.prevTask.component = null;
      if (node.Level == 'Unit') {
        this.prevTask.line = node.lineId;
        this.prevTask.lineName = node.lineName;
        this.prevTask.units = node.PrimaryId;
        this.prevTask.unitName = node.text;
        this.prevTask.displayMachine = `${node.lineName}/${node.text}`;
        this.prevTask.Plant = node.plant;
      } else if (node.Level == 'Assembly') {
        this.prevTask.assembly = node.PrimaryId;
        this.prevTask.assemblyName = node.text;
        this.prevTask.units = node.unitId;
        this.prevTask.unitName = node.unitName;
        this.prevTask.line = node.lineId;
        this.prevTask.lineName = node.lineName;
        this.prevTask.displayMachine = `${node.lineName}/${node.unitName}/${node.text}`;
        this.prevTask.Plant = node.plant;
      } else if (node.Level == 'SubAssembly') {
        this.prevTask.subAssembly = node.PrimaryId;
        this.prevTask.subAssemblyName = node.text;
        this.prevTask.assembly = node.assemblyId;
        this.prevTask.assemblyName = node.assemblyName;
        this.prevTask.units = node.unitId;
        this.prevTask.unitName = node.unitName;
        this.prevTask.line = node.lineId;
        this.prevTask.lineName = node.lineName;
        this.prevTask.displayMachine = `${node.lineName}/${node.unitName}/${node.assemblyName}/${node.text}`;
        this.prevTask.Plant = node.plant;
      } else if (node.Level == 'Component') {
        this.prevTask.component = node.PrimaryId;
        this.prevTask.componentName = node.text;
        this.prevTask.subAssembly = node.subAssemblyId;
        this.prevTask.subAssemblyName = node.subAssemblyName;
        this.prevTask.assembly = node.assemblyId;
        this.prevTask.assemblyName = node.assemblyName;
        this.prevTask.units = node.unitId;
        this.prevTask.unitName = node.unitName;
        this.prevTask.line = node.lineId;
        this.prevTask.lineName = node.lineName;
        this.prevTask.displayMachine = `${node.lineName}/${node.unitName}/${node.assemblyName}/${node.subAssemblyName}/${node.text}`;
        this.prevTask.Plant = node.plant;
      }
    } else return;
  }

  openTreeModal(): void {
    const key = {
      GroupCode: this.groupSession?.groupCode,
      PlantCode: this.plantSession?.plantCode,
      UserCode: this.userSession?.userCode,
      level: 'Plant',
      CreatedBy: 0,
      IsOptional: 0,
      div_Id: '',
    };
    this.spinner.show();
    this.spinnerText = 'Fetching Tree Data';
    this.enterpriseGroupService.getTreeModal(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (!this.dialogBox) {
          const plantGroupData: PlantGroupElement[] = data.TreeModalList;
          this.plantGroupSource.data = plantGroupData;
          this.udpateNodeParentDetails();
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.isPlantGroupModelVisible = true;
        } else {
          this.plantGroupSource.data = data.TreeModalList;
          this.udpateNodeParentDetails();
          this.dialogBox = false;
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  udpateNodeParentDetails() {
    try {
      if (this.plantGroupSource.data && this.plantGroupSource.data.length) {
        this.plantGroupSource.data.forEach((group, groupIndex) => {
          if (group.children && group.children.length) {
            group.children.forEach((plant, plantIndex) => {
              plant.groupName = group.text;
              plant.groupId = group.PrimaryId;
              if (plant.children && plant.children.length) {
                plant.children.forEach(
                  (division: any, divisionIndex: number) => {
                    division.plantId = plant.PrimaryId;
                    division.plantName = plant.text;
                    division.groupName = group.text;
                    division.groupId = group.PrimaryId;
                    if (division.children && division.children.length) {
                      division.children.forEach(
                        (department: any, departmentIndex: number) => {
                          department.divisionId = division.PrimaryId;
                          department.divisionName = division.text;
                          department.plantId = plant.PrimaryId;
                          department.plantName = plant.text;
                          department.groupId = group.PrimaryId;
                          department.groupName = group.text;
                          if (
                            department.children &&
                            department.children.length
                          ) {
                            department.children.forEach((line: any) => {
                              line.departmentId = department.PrimaryId;
                              line.departmentName = department.text;
                              line.divisionId = division.PrimaryId;
                              line.divisionName = division.text;
                              line.plantId = plant.PrimaryId;
                              line.plantName = plant.text;
                              line.groupId = group.PrimaryId;
                              line.groupName = group.text;
                              if (line.children && line.children.length) {
                                line.children.forEach((unit: any) => {
                                  unit.lineId = line.PrimaryId;
                                  unit.lineName = line.text;
                                  unit.departmentId = department.PrimaryId;
                                  unit.departmentName = department.text;
                                  unit.divisionId = division.PrimaryId;
                                  unit.divisionName = division.text;
                                  unit.plantId = plant.PrimaryId;
                                  unit.plantName = plant.text;
                                  unit.groupId = group.PrimaryId;
                                  unit.groupName = group.text;
                                  if (unit.children && unit.children.length) {
                                    unit.children.forEach((assembly: any) => {
                                      assembly.unitName = unit.text;
                                      assembly.unitId = unit.PrimaryId;
                                      assembly.lineId = line.PrimaryId;
                                      assembly.lineName = line.text;
                                      assembly.departmentId =
                                        department.PrimaryId;
                                      assembly.departmentName = department.text;
                                      assembly.divisionId = division.PrimaryId;
                                      assembly.divisionName = division.text;
                                      assembly.plantId = plant.PrimaryId;
                                      assembly.plantName = plant.text;
                                      assembly.groupId = group.PrimaryId;
                                      assembly.groupName = group.text;
                                      if (
                                        assembly.children &&
                                        assembly.children.length
                                      ) {
                                        assembly.children.forEach(
                                          (subAssembly: any) => {
                                            subAssembly.assemblyName =
                                              assembly.text;
                                            subAssembly.assemblyId =
                                              assembly.PrimaryId;
                                            subAssembly.unitName = unit.text;
                                            subAssembly.unitId = unit.PrimaryId;
                                            subAssembly.lineId = line.PrimaryId;
                                            subAssembly.lineName = line.text;
                                            subAssembly.departmentId =
                                              department.PrimaryId;
                                            subAssembly.departmentName =
                                              department.text;
                                            subAssembly.divisionId =
                                              division.PrimaryId;
                                            subAssembly.divisionName =
                                              division.text;
                                            subAssembly.plantId =
                                              plant.PrimaryId;
                                            subAssembly.plantName = plant.text;
                                            subAssembly.groupId =
                                              group.PrimaryId;
                                            subAssembly.groupName = group.text;
                                            if (
                                              subAssembly.children &&
                                              subAssembly.children.length
                                            ) {
                                              subAssembly.children.forEach(
                                                (component: any) => {
                                                  component.subAssemblyName =
                                                    subAssembly.text;
                                                  component.subAssemblyId =
                                                    subAssembly.PrimaryId;
                                                  component.assemblyName =
                                                    assembly.text;
                                                  component.assemblyId =
                                                    assembly.PrimaryId;
                                                  component.unitName =
                                                    unit.text;
                                                  component.unitId =
                                                    unit.PrimaryId;
                                                  component.lineId =
                                                    line.PrimaryId;
                                                  component.lineName =
                                                    line.text;
                                                  component.departmentId =
                                                    department.PrimaryId;
                                                  component.departmentName =
                                                    department.text;
                                                  component.divisionId =
                                                    division.PrimaryId;
                                                  component.divisionName =
                                                    division.text;
                                                  component.plantId =
                                                    plant.PrimaryId;
                                                  component.plantName =
                                                    plant.text;
                                                  component.groupId =
                                                    group.PrimaryId;
                                                  component.groupName =
                                                    group.text;
                                                }
                                              );
                                            }
                                          }
                                        );
                                      }
                                    });
                                  }
                                });
                              }
                            });
                          }
                        }
                      );
                    }
                  }
                );
              }
            });
          }
        });
      }
    } catch (err: any) {
      this.toaster.error(err, 'Error');
    }
  }

  closePlantGroupModel(): void {
    this.updateOrderprocessingData = false;
  }

  // collapse group view
  collapseAllNode(): void {
    this.treeControl.collapseAll();
  }

  // expand group view
  expandAllNode(): void {
    this.treeControl.expandAll();
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  public localizeHeaderJson(parameters: any) {
    let headerIdentifier = parameters.colDef.headerName;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  opensideComponentModal(): void {
    // this.formMode = true;
    this.displayComponentModal = true;
  }
  closeaddNewPlantItemModel(): void {
    this.displayComponentModal = false;
  }

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }
  replaceString(value: any): any {
    const data = value.split('"')[1];
    if (data === 'IsOptionalplanticon') {
      return true;
    } else {
      return false;
    }
  }

  setFrequencyDuration() {
    const obj = this.frequencyList.find(
      (freq: any) => freq.ID == this.prevTask.Frequency
    );
    this.FreqDuration = obj.Duration;
    this.prevTask.Duration = null;
  }
  durationChange(val) {
    // this.FreqDuration Selected Frequency
    if (val <= 1440) return;
    else {
      this.prevTask.Duration = null;
      this.toaster.warning('Duration must be lessthan 1 Day');
    }
  }
  setMaintenanceType() {
    const obj = this.TaskTypeList.find(
      (tt: any) => tt.ID == this.prevTask.TaskType
    );
    const newType = obj?.MaintenanceType ?? '';

    if (!this.edited || !newType) {
      this.prevTask.MaintenanceType = newType;
      return;
    }

    let confirmationText = '';
    if (newType === 'Condition Based') {
      confirmationText = 'All Technician Tasks will be deleted';
    } else if (newType === 'Time Based') {
      confirmationText = 'All parameters will be deleted';
    }

    if (confirmationText) {
      Swal.fire({
        title: 'Are you sure?',
        text: confirmationText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        this.prevTask.MaintenanceType = result.isConfirmed
          ? newType
          : this.editMaintenanceType ?? '';
        this.prevTask.TaskType = result.isConfirmed
          ? this.prevTask.TaskType
          : this.editTaskTypeID;
        this.existingTaskRow.MaintenanceType != newType ? this.disableFrq = false : this.disableFrq = true;

      });
    } else {
      this.prevTask.MaintenanceType = newType;
    }
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
    // return false;
  }

  SelectVarUnitName(unitname: any): any {
    if (unitname.title === 'UNT') {
      this.varUnitName = unitname.name;
      this.isPlantGroupModelVisible = false;
    }
  }
  resetForm(form: FormGroup, value: any) {
    form.get(value)?.setValue('');
  }

  getDropdownData(i: number) {
    if (i == 1) {
      const ind = this.GroupList.findIndex(
        (obj: any) => obj.egId == this.groupSession?.groupCode
      );
      this.PlantList = this.GroupList[ind].plants;
      for (var i = 0; i < this.PlantList.length; i++) {
        if (this.PlantList[i].isDeleted == true) {
          this.PlantList.splice(i, 1);
          i--;
        }
      }
      this.PlantList.sort(function (a: any, b: any) {
        return a.ptId - b.ptId;
      });
    } else if (i == 2) {
      this.filterFrequencyList = this.frequencyList.filter(
        (obj: any) =>
          obj.Group.egId == this.groupSession?.groupCode &&
          obj.Plant.ptId == this.plantSession?.plantCode
      );
      this.isInit = true;
      this.getTool();
      this.getFrequency();
      this.getTaskType();
      this.getWOType();
      this.getUserList();
      this.getTreeMasterData();
    }
  }

  onFilterChanged(event: any) {
    this.gridOptions.api.setQuickFilter(event.value);
  }
  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', () => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  onChangePage(event: any) {
    // this.TaskPage.length = event.api.paginationProxy.masterRowCount
    // this.TaskPage.pageSize = event.api.paginationProxy.pageSize
    // this.TaskPage.pageIndex = event.api.paginationProxy.currentPage
    // if (this.TaskPage.pageIndex != this.oldTaskPageIndex){
    //   this.oldTaskPageIndex = this.TaskPage.pageIndex
    //   this.getTask()
    // }
  }
  //_______________________________________________________________________
  openDialog(name: any): void {
    if (this.groupSession?.groupCode && this.plantSession?.plantCode) {
      this.dialogBox = true;
      // this.openTreeModal();
      let dialogRef = this.dialog.open(PreventiveDialogComponent, {
        disableClose: true,
        width: '500px',
        data: { moduleName: name },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == undefined) {
        } else {
          this.excelFile = result;
          this.validateExcelData();
        }
      });
    } else {
      this.toaster.warning('Please Fill Header Fields', 'Warning');
      return;
    }
  }

  openedChange(opened: boolean) {
    this.opentype = opened ? 'opened' : 'closed';
  }

  validateExcelData() {
    try {
      let TechnoRow = 1;
      let TTRow = 1;
      let ToolRow = 1;
      let FreRow = 1;
      let TaskRow = 1;
      let TechRow = 1;

      if (
        this.excelFile &&
        this.excelFile.Technology &&
        this.excelFile.Technology.length
      ) {
        for (let obj of this.excelFile.Technology) {
          if (!obj['Group']) {
            if (!obj['Group']) {
              this.toaster.error(
                `Group can't be empty on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            return;
          } else if (!obj['Plant']) {
            if (!obj['Plant']) {
              this.toaster.error(
                `Plant can't be empty on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            return;
          } else if (!obj['Activity Type Name']) {
            if (!obj['Activity Type Name']) {
              this.toaster.error(
                `Activity Type Name can't be empty on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            return;
          } else {
            const activityTypeName = obj['Activity Type Name']?.trim();
            const existingWOType = this.WOTypeList.find((wo: any) => {
              return (
                wo.Name?.trim().toLowerCase() ===
                activityTypeName.trim().toLowerCase()
              );
            });

            if (existingWOType) {
              this.toaster.error(
                `Activity Type Name '${activityTypeName}' already exists in system on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              return;
            }
            let groupobj: any;
            let plantobj: any;
            let uniqueData: any;
            let existXLData: any;

            const TechnologyData: any = {
              Group: this.groupSession?.groupCode,
              Plant: this.plantSession?.plantCode,
              Desc: '',
              Name: '',
              CreatedAt: '',
              CreatedBy: '',
            };

            if (
              this.groupSession?.groupName.trim().toLowerCase() ===
              obj['Group'].trim().toLowerCase()
            ) {
              // TechnologyData.Group = groupobj.PrimaryId;
              // plantobj = groupobj.children.find((pnt: any) => {
              //   const a = obj['Plant'].trim().toLowerCase();
              //   const b = pnt.text?.trim().toLowerCase();
              //   return a == b;
              // });
              if (
                this.plantSession?.plantName.trim().toLowerCase() ===
                obj['Plant'].trim().toLowerCase()
              ) {
                // TechnologyData.Plant = plantobj.PrimaryId;

                uniqueData = this.AllWOType.find((tt: any) => {
                  const a = obj['Activity Type Name'].trim().toLowerCase();
                  const b = tt.Name.trim().toLowerCase();
                  return (
                    tt.Group &&
                    tt.Group.egId == TechnologyData.Group &&
                    tt.Plant &&
                    tt.Plant.ptId == TechnologyData.Plant &&
                    a == b
                  );
                });

                if (!uniqueData) {
                  TechnologyData.Name = obj['Activity Type Name'];
                  TechnologyData.Desc = obj['Description'];
                }
                // else {
                //   this.toaster.error(`Technology ${obj["Technology"]} already exist on row ${TechnoRow} on Technology Sheet`, 'Error', {
                //     timeOut: 3000,
                //   });
                //   this.excelFile = [];
                //   this.TechnologyMasterData = [];
                //   return;
                // }
              } else {
                this.toaster.error(
                  `Plant ${obj['Plant']} not found in database on row ${TechnoRow} on Activity Type Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.TechnologyMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Group ${obj['Group']} not found in database on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              return;
            }

            TechnologyData.CreatedAt = new Date();
            TechnologyData.CreatedBy = this.userSession?.userCode;

            if (TechnoRow != 1) {
              existXLData = this.TechnologyMasterData.find((tt: any) => {
                return (
                  tt.Name == TechnologyData.Name &&
                  tt.Group == TechnologyData.Group &&
                  tt.Plant == TechnologyData.Plant
                );
              });
            }
            if (!uniqueData && !existXLData)
              this.TechnologyMasterData.push(TechnologyData);
          }
          TechnoRow++;
        }
      }
      // Tool Tab is removed from Excel
      if (this.excelFile && this.excelFile.Tool && this.excelFile.Tool.length) {
        for (let obj of this.excelFile.Tool) {
          if (!obj['Group']) {
            if (!obj['Group']) {
              this.toaster.error(
                `Group can't be empty on row ${ToolRow} in Tool Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            return;
          } else if (!obj['Plant']) {
            if (!obj['Plant']) {
              this.toaster.error(
                `Plant can't be empty on row ${ToolRow} in Tool Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            return;
          } else if (!obj['Tool Name']) {
            if (!obj['Tool Name']) {
              this.toaster.error(
                `Tool Name can't be empty on row ${ToolRow} in Tool Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            return;
          } else {
            let groupobj: any;
            let plantobj: any;
            let uniqueData: any;
            let existXLData: any;

            const ToolData: any = {
              Group: this.groupSession?.groupCode,
              Plant: this.plantSession?.plantCode,
              Name: '',
              CreatedAt: '',
              CreatedBy: '',
            };

            groupobj = this.plantGroupSource.data.find((grp: any) => {
              const a = obj['Group'].trim().toLowerCase();
              const b = grp.text.trim().toLowerCase();
              return a == b;
            });

            if (groupobj) {
              ToolData.Group = groupobj.PrimaryId;
              plantobj = groupobj.children.find((pnt: any) => {
                const a = obj['Plant'].trim().toLowerCase();
                const b = pnt.text?.trim().toLowerCase();
                return a == b;
              });
              if (plantobj) {
                ToolData.Plant = plantobj.PrimaryId;
                uniqueData = this.AllTool.find((tool: any) => {
                  const a = obj['Tool Name'].trim().toLowerCase();
                  const b = tool.Name.trim().toLowerCase();
                  return (
                    tool.Group &&
                    tool.Group.egId == ToolData.Group &&
                    tool.Plant &&
                    tool.Plant.ptId == ToolData.Plant &&
                    a == b
                  );
                });
                if (!uniqueData) ToolData.Name = obj['Tool Name'];
              } else {
                this.toaster.error(
                  `Plant ${obj['Plant']} not found in database on row ${ToolRow} in Tool Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.TechnologyMasterData = [];
                this.ToolMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Group ${obj['Group']} not found in database on row ${ToolRow} in Tool Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.ToolMasterData = [];
              return;
            }

            ToolData.CreatedAt = new Date();
            ToolData.CreatedBy = this.userSession?.userCode;

            if (ToolRow != 1) {
              existXLData = this.ToolMasterData.find((tool: any) => {
                return (
                  tool.Name == ToolData.Name &&
                  tool.Group == ToolData.Group &&
                  tool.Plant == ToolData.Plant
                );
              });
            }
            if (!uniqueData && !existXLData) this.ToolMasterData.push(ToolData);
          }
          ToolRow++;
        }
      }

      if (
        this.excelFile &&
        this.excelFile.Frequency &&
        this.excelFile.Frequency.length
      ) {
        for (let obj of this.excelFile.Frequency) {
          if (!obj['Group']) {
            if (!obj['Group']) {
              this.toaster.error(
                `Group can't be empty on row ${FreRow} on Frequency Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            return;
          } else if (!obj['Plant']) {
            if (!obj['Plant']) {
              this.toaster.error(
                `Plant can't be empty on row ${FreRow} on Frequency Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            return;
          } else if (!obj['Frequency Name']) {
            if (!obj['Frequency Name']) {
              this.toaster.error(
                `Frequency Name can't be empty on row ${FreRow} on Frequency Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            return;
          } else if (
            !obj['Duration / days'] ||
            typeof obj['Duration / days'] != 'number'
          ) {
            if (!obj['Duration / days']) {
              this.toaster.error(
                `Duration days can't be empty on row ${FreRow} on Frequency Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.ToolMasterData = [];
              this.FrequencyMasterData = [];
              return;
            }

            if (typeof obj['Duration / days'] != 'number') {
              this.toaster.error(
                `Duration days should be a number on row ${FreRow} on Frequency Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            return;
          } else {
            const frequencyName = obj['Frequency Name']?.trim();
            const chkFrequency = this.frequencyList.find((fre: any) => {
              return (
                fre.Name?.trim().toLowerCase() ===
                frequencyName.trim().toLowerCase()
              );
            });

            if (chkFrequency) {
              this.toaster.error(
                `Frequency '${frequencyName}' already exists in system on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              return;
            }
            let groupobj: any;
            let plantobj: any;
            let uniqueData: any;
            let existXLData: any;

            const FrequencyData: any = {
              Group: this.groupSession?.groupCode,
              Plant: this.plantSession?.plantCode,
              Name: '',
              Duration: '',
              CreatedAt: '',
              CreatedBy: '',
            };

            // groupobj = this.plantGroupSource.data.find((grp: any) => {
            //   const a = obj['Group'].trim().toLowerCase();
            //   const b = grp.text.trim().toLowerCase();
            //   return a == b;
            // });

            if (
              this.groupSession?.groupName.trim().toLowerCase() ===
              obj['Group'].trim().toLowerCase()
            ) {
              // FrequencyData.Group = groupobj.PrimaryId;
              // plantobj = groupobj.children.find((pnt: any) => {
              //   const a = obj['Plant'].trim().toLowerCase();
              //   const b = pnt.text?.trim().toLowerCase();
              //   return a == b;
              // });
              if (
                this.plantSession?.plantName.trim().toLowerCase() ===
                obj['Plant'].trim().toLowerCase()
              ) {
                // FrequencyData.Plant = plantobj.PrimaryId;
                uniqueData = this.AllFrequency.find((fre: any) => {
                  const a = obj['Frequency Name'].trim().toLowerCase();
                  const b = fre.Name.trim().toLowerCase();
                  return (
                    fre.Group &&
                    fre.Group.egId == FrequencyData.Group &&
                    fre.Plant &&
                    fre.Plant.ptId == FrequencyData.Plant &&
                    a == b
                  );
                });
                if (!uniqueData) {
                  FrequencyData.Name = obj['Frequency Name'];
                  FrequencyData.Duration = obj['Duration / days'];
                }
                // else {
                //   this.toaster.error(`Frequency ${obj["Frequency Name"]} already exist on row ${FreRow} on Frequency Sheet`, 'Error', {
                //     timeOut: 3000,
                //   });
                //   this.excelFile = [];
                //   this.TechnologyMasterData = [];
                //   this.ToolMasterData = [];
                //   this.FrequencyMasterData = [];
                //   return;
                // }
              } else {
                this.toaster.error(
                  `Plant ${obj['Plant']} not found in database on row ${FreRow} on Frequency Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.TechnologyMasterData = [];
                this.ToolMasterData = [];
                this.FrequencyMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Group ${obj['Group']} not found in database on row ${FreRow} on Frequency Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.ToolMasterData = [];
              this.FrequencyMasterData = [];
              return;
            }

            FrequencyData.CreatedAt = new Date();
            FrequencyData.CreatedBy = this.userSession?.userCode;

            if (FreRow != 1) {
              existXLData = this.FrequencyMasterData.find((fre: any) => {
                return (
                  fre.Name == FrequencyData.Name &&
                  fre.Group == FrequencyData.Group &&
                  fre.Plant == FrequencyData.Plant
                );
              });
              // if (existXLData) {
              //   this.toaster.error(`Frequency ${FrequencyData.Name} already exist in this xl sheet on row ${FreRow} on Frequency Sheet`, 'Error', {
              //     timeOut: 3000,
              //   });
              //   this.excelFile = [];
              //   this.TechnologyMasterData = [];
              //   this.ToolMasterData = [];
              //   this.FrequencyMasterData = [];
              //   return;
              // }
            }
            if (!uniqueData && !existXLData)
              this.FrequencyMasterData.push(FrequencyData);
          }
          FreRow++;
        }
      }

      if (
        this.excelFile &&
        this.excelFile.TaskType &&
        this.excelFile.TaskType.length
      ) {
        for (let obj of this.excelFile.TaskType) {
          if (!obj['Group']) {
            if (!obj['Group']) {
              this.toaster.error(
                `Group can't be empty on row ${TTRow} in Task Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskTypeMasterData = [];
            return;
          } else if (!obj['Plant']) {
            if (!obj['Plant']) {
              this.toaster.error(
                `Plant can't be empty on row ${TTRow} in Task Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskTypeMasterData = [];
            return;
          } else if (!obj['Task Type Name']) {
            if (!obj['Task Type Name']) {
              this.toaster.error(
                `Task Type Name can't be empty on row ${TTRow} in Task Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskTypeMasterData = [];
            return;
          } else if (!obj['Maintenance Type']) {
            if (!obj['Maintenance Type']) {
              this.toaster.error(
                `Maintenance Type can't be empty on row ${TTRow} in Task Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskTypeMasterData = [];
            return;
          } else {
            const taskTypeName = obj['Task Type Name']?.trim();
            const maintenanceTypeName = obj['Maintenance Type']?.trim();
            const chkTaskType = this.TaskTypeList.find((tasktype: any) => {
              const a = tasktype?.Name?.trim().toLowerCase();
              const b = taskTypeName.toLowerCase();
              const c = tasktype?.MaintenanceType?.trim().toLowerCase();
              const d = maintenanceTypeName.toLowerCase();
              return a === b && c === d;
            });

            if (chkTaskType) {
              this.toaster.error(
                `Task Type '${taskTypeName}' with Maintenance Type '${maintenanceTypeName}' already exists in system on row ${TechnoRow} on Activity Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              return;
            }
            let groupobj: any;
            let plantobj: any;
            let uniqueData: any;
            let existXLData: any;

            const TaskTypeData: any = {
              Group: this.groupSession?.groupCode,
              Plant: this.plantSession?.plantCode,
              Name: '',
              MaintenanceType: '',
              CreatedAt: '',
              CreatedBy: '',
            };

            // groupobj = this.plantGroupSource.data.find((grp: any) => {
            //   const a = obj['Group'].trim().toLowerCase();
            //   const b = grp.text.trim().toLowerCase();
            //   return a == b;
            // });

            if (
              this.groupSession?.groupName.trim().toLowerCase() ===
              obj['Group'].trim().toLowerCase()
            ) {
              // TaskTypeData.Group = groupobj.PrimaryId;
              // plantobj = groupobj.children.find((pnt: any) => {
              //   const a = obj['Plant'].trim().toLowerCase();
              //   const b = pnt.text?.trim().toLowerCase();
              //   return a == b;
              // });
              if (
                this.plantSession?.plantName.trim().toLowerCase() ===
                obj['Plant'].trim().toLowerCase()
              ) {
                // TaskTypeData.Plant = plantobj.PrimaryId;
                uniqueData = this.AllTaskType.find((tt: any) => {
                  const a = obj['Task Type Name'].trim().toLowerCase();
                  const b = tt?.Name?.trim().toLowerCase();
                  const c = obj['Maintenance Type'].trim().toLowerCase();
                  const d = tt?.MaintenanceType?.trim().toLowerCase();
                  return (
                    tt.Group &&
                    tt.Group.egId == TaskTypeData.Group &&
                    tt.Plant &&
                    tt.Plant.ptId == TaskTypeData.Plant &&
                    a == b &&
                    c == d
                  );
                });
                if (!uniqueData) {
                  TaskTypeData.Name = obj['Task Type Name'];
                  TaskTypeData.MaintenanceType = obj['Maintenance Type'];
                }
                // else {
                //   this.toaster.error(`Task Type ${obj["Task Type Name"]} already exist on row ${TTRow} in Task Type Sheet`, 'Error', {
                //     timeOut: 3000,
                //   });
                //   this.excelFile = [];
                //   this.TechnologyMasterData = [];
                //   this.ToolMasterData = [];
                //   this.FrequencyMasterData = [];
                //   this.TaskTypeMasterData = [];
                //   return;
                // }
              } else {
                this.toaster.error(
                  `Plant ${obj['Plant']} not found in database on row ${TTRow} in Task Type Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.TechnologyMasterData = [];
                this.ToolMasterData = [];
                this.FrequencyMasterData = [];
                this.TaskTypeMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Group ${obj['Group']} not found in database on row ${TTRow} in Task Type Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.ToolMasterData = [];
              this.FrequencyMasterData = [];
              this.TaskTypeMasterData = [];
              return;
            }

            TaskTypeData.CreatedAt = new Date();
            TaskTypeData.CreatedBy = this.userSession?.userCode;

            if (TTRow != 1) {
              existXLData = this.TaskTypeMasterData.find((tt: any) => {
                return (
                  tt.Name == TaskTypeData.Name &&
                  tt.Group == TaskTypeData.Group &&
                  tt.Plant == TaskTypeData.Plant
                );
              });
              // if (existXLData) {
              //   this.toaster.error(`Task Type ${TaskTypeData.Name} already exist in this xl sheet on row ${TTRow} in Task Type Sheet`, 'Error', {
              //     timeOut: 3000,
              //   });
              //   this.excelFile = [];
              //   this.TechnologyMasterData = [];
              //   this.ToolMasterData = [];
              //   this.FrequencyMasterData = [];
              //   this.TaskTypeMasterData = [];
              //   return;
              // }
            }
            if (!uniqueData && !existXLData)
              this.TaskTypeMasterData.push(TaskTypeData);
          }
          TTRow++;
        }
      }

      if (this.excelFile && this.excelFile.Task && this.excelFile.Task.length) {
        for (let obj of this.excelFile.Task) {
          if (!obj['Group*']) {
            if (!obj['Group*']) {
              this.toaster.error(
                `Group can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Plant*']) {
            if (!obj['Plant*']) {
              this.toaster.error(
                `Plant can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Description*']) {
            if (!obj['Description*']) {
              this.toaster.error(
                `Description can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Task Type*']) {
            if (!obj['Task Type*']) {
              this.toaster.error(
                `Task Type can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Maintenance Type*']) {
            if (!obj['Maintenance Type*']) {
              this.toaster.error(
                `Maintenance Type can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Frequency'] && obj['Maintenance Type*'] === 'Time Based') {
            if (!obj['Frequency'] && obj['Maintenance Type*'] === 'Time Based') {
              this.toaster.error(
                `Frequency is required when Maintenance Type is 'Time Based' on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Activity Type*']) {
            if (!obj['Activity Type*']) {
              this.toaster.error(
                `Activity Type can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (
            (!obj['Duration / Min'] ||
              typeof obj['Duration / Min'] != 'number') && obj['Maintenance Type*'] === 'Time Based'
          ) {
            if (!obj['Duration / Min*'] && obj['Maintenance Type*'] === 'Time Based') {
              this.toaster.error(
                `Duration Min is required when Maintenance Type is 'Time Based' on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.TaskTypeMasterData = [];
              this.ToolMasterData = [];
              this.FrequencyMasterData = [];
              this.TaskMasterData = [];
              return;
            }
            if (obj['Duration / Min'] !== null && obj['Duration / Min'] !== undefined && obj['Duration / Min'] !== '') {

              if (typeof obj['Duration / Min'] != 'number') {
                this.toaster.error(
                  `Duration Min should be a number on row ${TaskRow} on Task Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
              }
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          }
          // else if (!obj['Spare Parts*']) {
          //   if (!obj['Spare Parts*']) {
          //     this.toaster.error(
          //       `Spare Parts can't be empty on row ${TaskRow} on Task Sheet`,
          //       'Error',
          //       {
          //         timeOut: 3000,
          //       }
          //     );
          //   }

          //   this.excelFile = [];
          //   this.TechnologyMasterData = [];
          //   this.TaskTypeMasterData = [];
          //   this.ToolMasterData = [];
          //   this.FrequencyMasterData = [];
          //   this.TaskMasterData = [];
          //   return;
          // }
          else if (!obj['Line*']) {
            if (!obj['Line*']) {
              this.toaster.error(
                `Line can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else if (!obj['Unit*']) {
            if (!obj['Unit*']) {
              this.toaster.error(
                `Unit can't be empty on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }

            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            return;
          } else {
            let groupobj: any;
            let plantobj: any;
            let divisionobj: any;
            let departmentobj: any;
            let lineobj: any;
            let unitobj: any;
            let assemblyobj: any;
            let subassemblyobj: any;
            let componentobj: any;
            let frequency: any;
            let tasktype: any;
            let activitytype: any;
            let treeobj: any;

            let uniqueData: any;
            let existXLData: any;

            let line: any;
            let unit: any;
            let assembly: any;
            let subassembly: any;
            let component: any;

            const Taskdata: any = {
              Group: this.groupSession?.groupCode,
              Plant: this.plantSession?.plantCode,
              Description: '',
              Technician: '',
              TaskType: '',
              Frequency: '',
              WOType: '',
              Duration: '',
              ChecklistIds: '',
              SpareParts: '',
              line: null,
              units: null,
              assembly: null,
              subAssembly: null,
              component: null,
              CreatedAt: '',
              CreatedBy: '',
              NextScheduleAt: '',
              MaintenanceType: '',
              FromTaskDate: '',
            };
            if (
              this.groupSession?.groupName.trim().toLowerCase() ===
              obj['Group*'].trim().toLowerCase()
            ) {
              if (
                this.plantSession?.plantName.trim().toLowerCase() ===
                obj['Plant*'].trim().toLowerCase()
              ) {
                Taskdata.MaintenanceType = obj['Maintenance Type*'];

                // Check for required technician if Maintenance Type is "Condition Based"
                if (Taskdata.MaintenanceType === 'Condition Based') {
                  const technicianValue = obj['Technician']?.trim();
                  if (!technicianValue) {
                    this.toaster.error(
                      `Technician is required when Maintenance Type is 'Condition Based' on row ${TaskRow} on Task Sheet`,
                      'Error',
                      {
                        timeOut: 3000,
                      }
                    );
                    return; // Stop further execution for this row
                  }
                }
                const technicianNames =
                  obj['Technician']?.split(',').map((name) => name.trim()) ||
                  [];

                const technicianCodes = technicianNames
                  .map((name) => {
                    const technician = this.userList.find(
                      (employee) => employee.fullName.trim() === name
                    );
                    return technician ? technician.employeeCode : null;
                  })
                  .filter((code) => !!code) // Removes null/undefined
                  .join(',');

                Taskdata.Technician = technicianCodes ? technicianCodes : null;
                const checklistNames =
                  obj['Checklists']?.split(',').map((name) => name.trim()) ||
                  [];

                const checklistIds = checklistNames
                  .map((name) => {
                    const checklist = this.checklists.find(
                      (c) => c.Listname === name
                    );
                    return checklist ? checklist.ChecklistId : null;
                  })
                  .filter((id) => id !== null && id !== undefined)
                  .join(',');

                Taskdata.ChecklistIds = checklistIds ? checklistIds : null;
                Taskdata.TaskType = obj['Task Type*'];
                this.FreqDuration = Taskdata.MaintenanceType === 'Time Based' ? obj['Duration / Min'] : null;
                let NextDate = new Date();
                NextDate.setDate(NextDate.getDate() + this.FreqDuration);
                Taskdata.Frequency = Taskdata.MaintenanceType === 'Time Based' ? obj['Frequency'] : null;
                Taskdata.NextScheduleAt = NextDate;
                Taskdata.NextScheduleAt = Taskdata.NextScheduleAt;
                Taskdata.WOType = obj['Activity Type*'];
                Taskdata.Description = obj['Description*'];
                Taskdata.Duration = Taskdata.MaintenanceType === 'Time Based' ? obj['Duration / Min'] : null;
                Taskdata.SpareParts = obj['Spare Parts'];
                if (obj['From Task Date (*YYYY-MM-DD)']) {
                  const fromDate = obj['From Task Date (*YYYY-MM-DD)'];
                  let dateValue = new Date(fromDate);
                  if (
                    dateValue instanceof Date &&
                    !isNaN(dateValue.getTime()) &&
                    dateValue.toString() !== 'Invalid Date'
                  ) {
                    const currentDate = new Date();
                    let selectedDate = new Date(dateValue);

                    selectedDate.setHours(currentDate.getHours());
                    selectedDate.setMinutes(currentDate.getMinutes());
                    selectedDate.setSeconds(currentDate.getSeconds());
                    Taskdata.FromTaskDate = new Date(selectedDate);
                  } else {
                    this.toaster.error(
                      `From Task Date (*YYYY-MM-DD) (${obj['From Task Date (*YYYY-MM-DD)*']}) date format is wrong on row ${TaskRow} on Task Sheet`,
                      'Error',
                      {
                        timeOut: 3000,
                      }
                    );
                    this.excelFile = [];
                    this.TaskTypeMasterData = [];
                    this.ToolMasterData = [];
                    this.FrequencyMasterData = [];
                    this.TaskMasterData = [];
                    return;
                  }
                } else {
                  Taskdata.FromTaskDate = null;
                }
                if (obj['To Task Date (*YYYY-MM-DD)']) {
                  const toDate = obj['To Task Date (*YYYY-MM-DD)'];
                  let dateValue = new Date(toDate);
                  if (
                    dateValue instanceof Date &&
                    !isNaN(dateValue.getTime()) &&
                    dateValue.toString() !== 'Invalid Date'
                  ) {
                    const currentDate = new Date();
                    let selectedDate = new Date(dateValue);
                    const selectedDateOnly = new Date(
                      selectedDate.getFullYear(),
                      selectedDate.getMonth(),
                      selectedDate.getDate()
                    );
                    const currentDateOnly = new Date(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      currentDate.getDate()
                    );
                    if (selectedDateOnly < currentDateOnly) {
                      this.toaster.error(
                        `To Task Date (*YYYY-MM-DD) (${moment(
                          selectedDate
                        ).format(
                          'DD/MM/YYYY'
                        )}) is in the past. ${TaskRow} on Task Sheet`,
                        'Error',
                        {
                          timeOut: 3000,
                        }
                      );
                      this.excelFile = [];
                      this.TaskTypeMasterData = [];
                      this.ToolMasterData = [];
                      this.FrequencyMasterData = [];
                      this.TaskMasterData = [];
                      return;
                    } else {
                      selectedDate.setHours(currentDate.getHours());
                      selectedDate.setMinutes(currentDate.getMinutes());
                      selectedDate.setSeconds(currentDate.getSeconds());
                      Taskdata.ToTaskDate = new Date(selectedDate);
                    }
                  } else {
                    this.toaster.error(
                      `To Task Date (*YYYY-MM-DD) (${obj['To Task Date (*YYYY-MM-DD)*']}) date format is wrong on row ${TaskRow} on Task Sheet`,
                      'Error',
                      {
                        timeOut: 3000,
                      }
                    );
                    this.excelFile = [];
                    this.TaskTypeMasterData = [];
                    this.ToolMasterData = [];
                    this.FrequencyMasterData = [];
                    this.TaskMasterData = [];
                    return;
                  }
                } else {
                  Taskdata.ToTaskDate = null;
                }
                line = this.LineAllList.find((line: any) => {
                  const a = String(obj['Line*'] || '')
                    .trim()
                    .toLowerCase();
                  const b = String(line.PL_Desc || '')
                    .trim()
                    .toLowerCase();

                  return a === b && line.PlantCode === Taskdata.Plant;
                });
                if (line) {
                  Taskdata.line = line.PL_Id;
                  unit = this.UnitAllList.find((unit: any) => {
                    const a = obj['Unit*'];
                    const b = unit.PU_Desc;
                    return (
                      a == b &&
                      unit.PlantCode == Taskdata.Plant &&
                      unit.PL_Id == Taskdata.line
                    );
                  });
                  if (unit) {
                    Taskdata.units = unit.PU_Id;
                    if (obj['Assembly']) {
                      assembly = this.AssemblyAllList.find((ass: any) => {
                        const a = obj['Assembly'].trim().toLowerCase();
                        const b = ass.Assbly_Desc.trim().toLowerCase();
                        return (
                          a == b &&
                          ass.PlantCode == Taskdata.Plant &&
                          ass.PU_Id == Taskdata.units
                        );
                      });
                      if (assembly) {
                        Taskdata.assembly = assembly.Assbly_Id;
                        if (obj['Sub Assembly']) {
                          subassembly = this.SubAssemblyAllList.find(
                            (subass: any) => {
                              const a = obj['Sub Assembly']
                                .trim()
                                .toLowerCase();
                              const b = subass.SAsbly_Desc.trim().toLowerCase();
                              return (
                                a == b &&
                                subass.PlantCode == Taskdata.Plant &&
                                subass.Assbly_Id == Taskdata.assembly
                              );
                            }
                          );
                          if (subassembly) {
                            Taskdata.subAssembly = subassembly.SAssbly_Id;
                            if (obj['Component']) {
                              component = this.ComponentAllList.find(
                                (comp: any) => {
                                  const a = obj['Component']
                                    .toLowerCase()
                                    .replace(/\s/g, '')
                                    .replace(/\n/g, '')
                                    .replace(/[()]/g, '')
                                    .trim();
                                  const b = comp.ComponentName.toLowerCase()
                                    .replace(/\s/g, '')
                                    .replace(/\n/g, '')
                                    .replace(/[()]/g, '')
                                    .trim();
                                  return (
                                    a == b &&
                                    comp.PlantCode == Taskdata.Plant &&
                                    comp.SAssbly_Id == Taskdata.subAssembly
                                  );
                                }
                              );
                              if (component) {
                                Taskdata.component = component.ComponentId;
                              } else {
                                this.toaster.error(
                                  `Component ${obj['Component']} not found in database on row ${TaskRow} on Task Sheet`,
                                  'Error',
                                  {
                                    timeOut: 3000,
                                  }
                                );
                                this.excelFile = [];
                                this.TechnologyMasterData = [];
                                this.TaskTypeMasterData = [];
                                this.ToolMasterData = [];
                                this.FrequencyMasterData = [];
                                this.TaskMasterData = [];
                                return;
                              }
                            }
                          } else {
                            this.toaster.error(
                              `Sub Assembly ${obj['Sub Assembly']} not found in database on row ${TaskRow} on Task Sheet`,
                              'Error',
                              {
                                timeOut: 3000,
                              }
                            );
                            this.excelFile = [];
                            this.TechnologyMasterData = [];
                            this.TaskTypeMasterData = [];
                            this.ToolMasterData = [];
                            this.FrequencyMasterData = [];
                            this.TaskMasterData = [];
                            return;
                          }
                        }
                      } else {
                        this.toaster.error(
                          `Assembly ${obj['Assembly']} not found in database on row ${TaskRow} on Task Sheet`,
                          'Error',
                          {
                            timeOut: 3000,
                          }
                        );
                        this.excelFile = [];
                        this.TechnologyMasterData = [];
                        this.TaskTypeMasterData = [];
                        this.ToolMasterData = [];
                        this.FrequencyMasterData = [];
                        this.TaskMasterData = [];
                        return;
                      }
                    }
                  } else {
                    this.toaster.error(
                      `Unit ${obj['Unit*']} not found in database on row ${TaskRow} on Task Sheet`,
                      'Error',
                      {
                        timeOut: 3000,
                      }
                    );
                    this.excelFile = [];
                    this.TechnologyMasterData = [];
                    this.TaskTypeMasterData = [];
                    this.ToolMasterData = [];
                    this.FrequencyMasterData = [];
                    this.TaskMasterData = [];
                    return;
                  }
                } else {
                  this.toaster.error(
                    `Line ${obj['Line*']} not found in database on row ${TaskRow} on Task Sheet`,
                    'Error',
                    {
                      timeOut: 3000,
                    }
                  );
                  this.excelFile = [];
                  this.TechnologyMasterData = [];
                  this.TaskTypeMasterData = [];
                  this.ToolMasterData = [];
                  this.FrequencyMasterData = [];
                  this.TaskMasterData = [];
                  return;
                }
              } else {
                this.toaster.error(
                  `Plant ${obj['Plant*']} not found in database on row ${TaskRow} on Task Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.TechnologyMasterData = [];
                this.TaskTypeMasterData = [];
                this.ToolMasterData = [];
                this.FrequencyMasterData = [];
                this.TaskMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Group ${obj['Group*']} not found in database on row ${TaskRow} on Task Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.TaskTypeMasterData = [];
              this.ToolMasterData = [];
              this.FrequencyMasterData = [];
              this.TaskMasterData = [];
              return;
            }

            Taskdata.CreatedAt = new Date();
            Taskdata.CreatedBy = this.userSession?.userCode;
            this.TaskMasterData.push(Taskdata);
          }
          TaskRow++;
        }
      }

      if (
        this.excelFile &&
        this.excelFile.Technician &&
        this.excelFile.Technician.length
      ) {
        for (let obj of this.excelFile.Technician) {
          if (!obj['Group']) {
            if (!obj['Group']) {
              this.toaster.error(
                `Group can't be empty on row ${TechRow} in Technician Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            this.TechnicianMasterData = [];
            return;
          } else if (!obj['Plant']) {
            if (!obj['Plant']) {
              this.toaster.error(
                `Plant can't be empty on row ${TechRow} in Technician Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            this.TechnicianMasterData = [];
            return;
          } else if (!obj['Technician']) {
            if (!obj['Technician']) {
              this.toaster.error(
                `Technician can't be empty on row ${TechRow} in Technician Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
            }
            this.excelFile = [];
            this.TechnologyMasterData = [];
            this.TaskTypeMasterData = [];
            this.ToolMasterData = [];
            this.FrequencyMasterData = [];
            this.TaskMasterData = [];
            this.TechnicianMasterData = [];
            return;
          } else {
            let groupobj: any;
            let plantobj: any;
            let checkgrppnt: any;
            let uniqueData: any;
            let existXLData: any;
            let existXLTech: any;
            const TechnicianData: any = {
              Data: {
                ID: 0,
                RMPM: 'PM',
                Name: [],
                CreatedAt: '',
                CreatedBy: '',
              },
              HeaderData: {
                Group: this.groupSession?.groupCode,
                Plant: this.plantSession?.plantCode,
              },
            };

            // groupobj = this.plantGroupSource.data.find((grp: any) => {
            //   const a = obj['Group'].trim().toLowerCase();
            //   const b = grp.text.trim().toLowerCase();
            //   return a == b;
            // });

            if (
              this.groupSession?.groupName.trim().toLowerCase() ===
              obj['Group'].trim().toLowerCase()
            ) {
              // TechnicianData.HeaderData.Group = groupobj.PrimaryId;
              // plantobj = groupobj.children.find((pnt: any) => {
              //   const a = obj['Plant'].trim().toLowerCase();
              //   const b = pnt.text?.trim().toLowerCase();
              //   return a == b;
              // });

              if (
                this.plantSession?.plantName.trim().toLowerCase() ===
                obj['Plant'].trim().toLowerCase()
              ) {
                // TechnicianData.HeaderData.Plant = plantobj.PrimaryId;
                const userobj = this.orgUserList.find(
                  (employee) =>
                    employee.fullName.trim() === obj['Technician'].trim()
                );
                // let userobj = this.orgUserList.find((user: any) => {
                //   const isInt = Number.isInteger(obj['Technician']);
                //   const a = isInt
                //     ? obj['Technician']
                //     : obj['Technician'].trim().toLowerCase();
                //   const b =
                //     user.FirstName.trim().toLowerCase() +
                //     ' ' +
                //     user.lastName.trim().toLowerCase();
                //   return a == b;
                // });
                if (userobj) {
                  let techobj = this.TechnicianList.find((tech: any) => {
                    const a = tech.UserId;
                    const b = userobj.employeeCode;
                    return a == b;
                  });
                  if (!techobj) {
                    if (TechRow != 1) {
                      let existXLData = this.TechnicianMasterData.find(
                        (tech: any) => {
                          return (
                            tech.HeaderData.Plant ==
                            TechnicianData.HeaderData.Plant
                          );
                        }
                      );
                      if (existXLData) {
                        existXLTech = existXLData.Data.Name.find(
                          (techID: any) => {
                            return techID == userobj.employeeCode;
                          }
                        );
                      }
                      checkgrppnt = this.TechnicianMasterData.find(
                        (grppnt: any) => {
                          return (
                            TechnicianData.HeaderData.Group ==
                            grppnt.HeaderData.Group &&
                            TechnicianData.HeaderData.Plant ==
                            grppnt.HeaderData.Plant
                          );
                        }
                      );
                      if (checkgrppnt) {
                        checkgrppnt.Data.Name.push(userobj.employeeCode);
                      } else {
                        TechnicianData.Data.Name.push(userobj.employeeCode);
                      }
                    } else {
                      TechnicianData.Data.Name.push(userobj.employeeCode);
                    }
                  } else {
                    if (techobj.Plant.ptId == TechnicianData.HeaderData.Plant) {
                      if (TechRow != 1) {
                        let existXLData = this.TechnicianMasterData.find(
                          (tech: any) => {
                            return (
                              tech.HeaderData.Plant ==
                              TechnicianData.HeaderData.Plant
                            );
                          }
                        );
                        if (existXLData) {
                          existXLTech = existXLData.Data.Name.find(
                            (techID: any) => {
                              return techID == userobj.employeeCode;
                            }
                          );
                          // if (existXLTech) {
                          //   this.toaster.error(`Technician ${obj['Technician']} Already Exist In  XL Sheet On Row ${TechRow} in Technician Sheet`, 'Error', {
                          //     timeOut: 3000,
                          //   });
                          //   this.excelFile = [];
                          //   this.TechnologyMasterData = [];
                          //   this.TaskTypeMasterData = [];
                          //   this.ToolMasterData = [];
                          //   this.FrequencyMasterData = [];
                          //   this.TaskMasterData = [];
                          //   this.TechnicianMasterData = [];
                          //   return;
                          // }
                        }
                        checkgrppnt = this.TechnicianMasterData.find(
                          (grppnt: any) => {
                            return (
                              TechnicianData.HeaderData.Group ==
                              grppnt.HeaderData.Group &&
                              TechnicianData.HeaderData.Plant ==
                              grppnt.HeaderData.Plant
                            );
                          }
                        );
                        if (checkgrppnt) {
                          checkgrppnt.Data.Name.push(userobj.employeeCode);
                        } else {
                          TechnicianData.Data.Name.push(userobj.employeeCode);
                        }
                      } else {
                        TechnicianData.Data.Name.push(userobj.employeeCode);
                      }
                    } else {
                      // this.toaster.error(`Technician ${obj['Technician']} Already Assigned Another Group & Plant on row ${TechRow} in Technician Sheet`, 'Error', {
                      //   timeOut: 3000,
                      // });
                      // this.excelFile = [];
                      // this.TechnologyMasterData = [];
                      // this.TaskTypeMasterData = [];
                      // this.ToolMasterData = [];
                      // this.FrequencyMasterData = [];
                      // this.TaskMasterData = [];
                      // this.TechnicianMasterData = [];
                      // return;
                    }
                  }
                } else {
                  this.toaster.error(
                    `Technician ${obj['Technician']} not found in database on row ${TechRow} in Technician Sheet`,
                    'Error',
                    {
                      timeOut: 3000,
                    }
                  );
                  this.excelFile = [];
                  this.TechnologyMasterData = [];
                  this.TaskTypeMasterData = [];
                  this.ToolMasterData = [];
                  this.FrequencyMasterData = [];
                  this.TaskMasterData = [];
                  this.TechnicianMasterData = [];
                  return;
                }
              } else {
                this.toaster.error(
                  `Plant ${obj['Plant']} not found in database on row ${TechRow} in Technician Sheet`,
                  'Error',
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.TechnologyMasterData = [];
                this.TaskTypeMasterData = [];
                this.ToolMasterData = [];
                this.FrequencyMasterData = [];
                this.TaskMasterData = [];
                this.TechnicianMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Group ${obj['Group']} not found in database on row ${TechRow} in Technician Sheet`,
                'Error',
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.TechnologyMasterData = [];
              this.TaskTypeMasterData = [];
              this.ToolMasterData = [];
              this.FrequencyMasterData = [];
              this.TaskMasterData = [];
              this.TechnicianMasterData = [];
              return;
            }

            TechnicianData.Data.CreatedAt = new Date();
            TechnicianData.Data.CreatedBy = this.userSession?.userCode;

            if ((TechRow == 1 || !checkgrppnt) && !existXLTech)
              this.TechnicianMasterData.push(TechnicianData);
          }
          TechRow++;
        }
      }

      this.MasterPMDataOnSubmit();
    } catch (err: any) {
      this.toaster.error(err, 'Error', {
        timeOut: 3000,
      });
      this.excelFile = [];
      this.TechnologyMasterData = [];
      this.TaskTypeMasterData = [];
      this.ToolMasterData = [];
      this.FrequencyMasterData = [];
      this.TaskMasterData = [];
      this.TechnicianMasterData = [];
    }
  }

  onSelectionChanged(params: any) {
    const selectedNodes = params?.api?.getSelectedNodes();
    const selectedData = selectedNodes.map((node: any) => node.data);
    const uniqueStatuses = [...new Set(selectedData.map((d) => d.Status))];

    // Disallow mixed statuses
    if (uniqueStatuses.length > 1) {
      this.toaster.warning(
        'Warn',
        'Select tasks with the same Status: either Active or InActive.'
      );
      params.api.deselectAll(); // Clear all selections
      this.filteredRowsData = [];
      this.filteredRows = [];
      this.disableActive = true;
      return;
    }
    this.Status = uniqueStatuses[0] === 'Active' ? 'InActive' : 'Active'; // Default to 'InActive' if no selection
    // Set filtered rows and flags
    this.filteredRowsData = selectedData;
    this.filteredRows = selectedNodes;
    this.disableActive = selectedData.length === 0;

    if (selectedData.length === 1) {
      this.Active = selectedData[0].Status === 'Active';
    } else if (selectedData.length > 1) {
      this.Active = selectedData[0].Status === 'Active';
    }
  }

  inActiveTasks(): void {
    this.InActiveValidation = false;

    // Determine current status of selected tasks
    const currentStatus = this.filteredRowsData[0]?.Status; // Assumes all are same due to earlier validation
    const isCurrentlyActive = currentStatus === 'InActive';

    // Set dynamic values
    const actionText = isCurrentlyActive ? 'Active' : 'InActive';
    const swalTitle = 'Are you sure?';
    const swalText = `You want to ${actionText} Task!`;
    const swalConfirmText = `Yes, ${actionText} !`;

    Swal.fire({
      title: swalTitle,
      text: swalText,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: swalConfirmText,
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        const updatedArray = this.filteredRowsData.map((item: any) => ({
          TaskId: item.ID,
          InActive: isCurrentlyActive, // true if currently active (to inactivate), false if currently inactive (to activate)
        }));

        this.spinner.show();
        this.PrevConfigurationService.updateTaskStatus(updatedArray).subscribe(
          (response: any) => {
            this.getTask();
            if (response?.message === 'Updated') {
              this.toaster.success(`${actionText} Successfully`);
              this.disableActive = true;
            } else {
              this.toaster.error(response?.ErrorMessage);
            }
          }
        );
      } else {
        Swal.fire('Cancelled', 'Your selected task is safe :)');
        this.gridApi?.deselectAll();
        this.disableActive = true;
      }
    });
  }

  MasterPMDataOnSubmit() {
    this.spinnerText = 'Creating PM Master Data';
    this.spinner.show();
    if (this.TechnologyMasterData && this.TechnologyMasterData.length)
      this.TechnologyMasterData.map((row: any) => (row.RMPM = 'PM'));
    let data = {
      TechnologyMasterData: this.TechnologyMasterData,
      TaskTypeMasterData: this.TaskTypeMasterData,
      ToolMasterData: this.ToolMasterData,
      FrequencyMasterData: this.FrequencyMasterData,
      TaskMasterData: this.TaskMasterData,
      TechnicianMasterData: this.TechnicianMasterData,
    };
    this.PrevConfigurationService.PMMasterUpload(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.edited = false;
        if (res.status) {
          this.toaster.success(res.message);
          if (res.taskRows && res.taskRows > 0)
            this.toaster.success(res.message);
        }
        if (res.ProcessedFile) {
          this.toaster.error('Error', 'Sheet with invalid data is downloaded');
          this.DownloadErrorFile(res);
        }
        this.TechnologyMasterData = [];
        this.TaskTypeMasterData = [];
        this.ToolMasterData = [];
        this.FrequencyMasterData = [];
        this.TaskMasterData = [];
        this.TechnicianMasterData = [];
        this.isInit = true;
        this.getTool();
        this.getFrequency();
        this.getTaskType();
        this.getTask();
        this.getAllTechnician();
        this.getWOType();
      },
      (error: any) => {
        this.excelFile = [];
        this.TechnologyMasterData = [];
        this.TaskTypeMasterData = [];
        this.ToolMasterData = [];
        this.FrequencyMasterData = [];
        this.TaskMasterData = [];
        this.TechnicianMasterData = [];
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }
  DownloadErrorFile(response: any) {
    const byteCharacters = atob(response.ProcessedFile);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, 'PM_Configuration.xlsx');
    this.toaster.error(response.ErrorMessage);
  }
  reset() {
    this.FileData = [];
    this.FileList = [];
    this.EditFileData = [];
    this.edited = false;
    this.disableFrq = false;
    this.minDate = new Date();
    this.toTaskMinDate = new Date();
    this.disableToTaskDate = false;
  }

  // Checklist Popup Starts
  openChecklistModal(element: any): void {
    if (!this.permissionService.isUserHasPermission(this.isWrite)) {
      this.toaster.warning('user dont have permission');
      return;
    }
    let dialogRef = this.dialog.open(ChecklistDialogComponent, {
      disableClose: true,
      width: '80vw !important',
      height: 'auto',
      maxHeight: '90vh',
      minWidth: '80vw',
      data: element?.rowData,
    });
  }

  getRolesByPlant(): void {
    this.documentService.GetRoles().subscribe(
      (res) => {
        this.plantRoles = res;
        this.filterRoles = this.plantRoles.slice();
        if (this.filterRoles.length > 0) {
          const firstRole = this.filterRoles[0];
          // this.prevTaskForm.get('TechnicianRole')?.setValue(firstRole.roleId);
        }
      },
      ({ error }) => {
        this.toaster.show(error.message);
      }
    );
  }

  getAllQualityCheckListsNamesPreventiveMiantenance(unitId: any): void {
    this.spinner.show();
    const payload = {
      PlantCode: this.plantSession?.plantCode,
      UnitId: unitId,
    };
    this.PrevConfigurationService.getAllQualityCheckListsNamesPreventiveMiantenance(
      payload
    ).subscribe({
      next: (data) => {
        this.spinner.hide();
        this.checklists = data;
        this.filteredCheckLists = this.checklists.slice();
      },
      error: (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      },
    });
  }

  // toggleAllSelectionCheckList() {
  //   if (this.allSelectedCheckList.selected) {
  //     const allCheckLists = this.filteredCheckLists.map((x) => x.ChecklistId);
  //     this.prevTaskForm.controls.checklist.patchValue(['ALL', ...allCheckLists]);
  //   } else {
  //     this.prevTaskForm.controls.checklist.patchValue([]);
  //   }
  // }

  // tosslePerOneCheckList() {
  //   if (this.allSelectedCheckList.selected) {
  //     this.allSelectedCheckList.deselect();
  //     return;
  //   }
  //   if (
  //     this.prevTaskForm.controls.checklist.value.length == this.filteredCheckLists.length
  //   ) {
  //     const allCheckLists = this.filteredCheckLists.map((x) => x.ChecklistId);
  //     this.prevTaskForm.controls.checklist.patchValue(['ALL', ...allCheckLists]);
  //   }
  // }

  onChecklistSelectionChange(event: MatOptionSelectionChange, item: any): void {
    if (event.isUserInput) {
      const selected = this.prevTask.Checklist || [];

      if (event.source.selected) {
        if (selected.length >= 5) {
          event.source.deselect();
          this.toaster.warning('You can select a maximum of 5 checklists.');
        }
      }
    }
  }

  openHistoryModal(task: any): void {
    this.spinner.show();

    const historyLogData = {
      taskId: task.rowData.ID,
    };

    this.prevTaskService.PMTaskHistoryLog(historyLogData).subscribe(
      (data: any) => {
        this.historyLogs = data || [];

        this.spinner.hide();
        this.dialog.open(this.HistoryLogDetails, {
          height: 'auto',
          maxHeight: '90vh',
          width: '100%',
        });
      },
      (error) => {
        this.spinner.hide();
        const errorMessage = error?.error || 'Failed to load history logs';
        this.toaster.error(errorMessage);
      }
    );
  }

  viewPMTechTaskRow(technicianTask: any): void {
    this.spinner.show();
    const maintenanceType = JSON.parse(
      technicianTask.rowData?.UpdatedPMTaskJson
    )?.[0].MaintenanceType;
    // if (maintenanceType !== 'Time Based') {
    //   this.spinner.hide();
    //   this.toaster.warning(
    //     'you can view technician history for time base tasks only'
    //   );
    //   return;
    // }
    this.TaskNamePMHistory = JSON.parse(
      technicianTask.rowData?.UpdatedPMTaskJson
    )?.[0].Description;
    this.historyLogsTechnicianTask =
      JSON.parse(technicianTask?.rowData?.UpdatedPMTechnicianTaskJson) || [];

    this.spinner.hide();
    this.dialog.open(this.HistoryLogDetailsTechnicianTask, {
      height: 'auto',
      maxHeight: '90vh',
      width: '100%',
    });
  }

  parameterPMTechTaskRow(params: any): void {
    this.spinner.show();
    this.TaskNamePMHistory = JSON.parse(
      params.rowData?.UpdatedPMTaskJson
    )?.[0].Description;
    this.historyLogsParameter =
      JSON.parse(params?.rowData?.UpdatedParameterJson) || [];

    this.spinner.hide();
    this.dialog.open(this.HistoryLogParameterDetailsTechnicianTask, {
      height: 'auto',
      maxHeight: '90vh',
      width: '100%',
    });
  }


  downloadFile(params: any): any {
    const link = document.createElement('a');
    link.href = this.blobStorageUrl + params.data.FilePath;
    link.download = 'file';
    link.target = '_blank';
    link.click();
  }

  //  cellClickedPMHistory(params: any): void {
  //   const col = params.colDef.field;
  //   this.ButtonType = '';
  //   if (col === 'Attachments') {
  //     const files = JSON.parse(params.data?.UpdatedPMTaskJson)?.[0]?.UploadFile;
  //     this.ButtonType = params.event.target.textContent;
  //     if (this.ButtonType === 'cloud_download') {
  //       this.ButtonType = '';
  //       this.downloadFile(params);
  //     } else if (this.ButtonType === 'remove_red_eye') {
  //       this.ButtonType = '';
  //       this.doc = this.blobStorageUrl + files;
  //       const fileType = params.data.FileType;
  //       if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif') {
  //         this.images = [];
  //         this.fileType = 'img';
  //         this.images.push(this.doc);
  //       } else {
  //         this.fileType = 'doc';
  //       }
  //       this.displayMaximizable = true;
  //       //this.fileDesc = params.data.FileDescription;
  //     }
  //   }
  // }

  cellClickedPMHistory(params: any): void {
    const col = params.colDef.headerName;

    if (col === 'Attachments') {
      const files = JSON.parse(params.data?.UpdatedPMTaskJson)?.[0]?.UploadFile;

      if (files && typeof files === 'string' && files.trim().length > 0) {
        const basePath = Constants.BLOB_STORAGE_URL;
        const fileList = files.split(',').map((f: string) => basePath + f.trim());

        // build preview list with type detection
        this.filesToPreview = fileList.map((file: string) => {
          const ext = file.split('.').pop()?.toLowerCase() || '';
          let type = 'other';
          if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) type = 'img';
          else if (ext === 'pdf') type = 'pdf';
          else if (['doc', 'docx'].includes(ext)) type = 'doc';
          else if (['xls', 'xlsx'].includes(ext)) type = 'xls';
          else if (['ppt', 'pptx'].includes(ext)) type = 'ppt';

          return { url: file, type };
        });

        this.currentIndex = 0;
        this.displayMaximizable = true;
      }
    }
  }

  nextFile() {
    if (this.currentIndex < this.filesToPreview.length - 1) {
      this.currentIndex++;
    }
  }

  prevFile() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  setPopupbtns(): void {
    var pHeader = document.getElementsByClassName(
      'p-dialog-header'
    )[0] as HTMLElement;
    if (pHeader) {
      pHeader.style.display = 'flex';
      pHeader.style.justifyContent = 'flex-end';
      var pHeaderIcons = document.getElementsByClassName(
        'p-dialog-header-icons'
      )[0] as HTMLElement;
      pHeaderIcons.style.marginRight = '40px';
    }
  }

  uponHide() {
    this.displayMaximizable = false;
  }

  getParameters(): void {
    const key = { PUID: '0' };
    this.spinner.show();
    this.productivityservice.getVariableGroupParametrs(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.parameters = data.Table;
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  // onGridReadyPMHistory(params: any) {
  //   this.gridApiPMHistory = params.api;
  //   this.gridColumnApiPMHistory = params.columnApi;
  //   this.gridApiPMHistory.sizeColumnsToFit();
  // }

  // onGridReadyPMTechnicianHistory(params: any) {
  //   this.gridApiPMTechnicianHistory = params.api;
  //   this.gridColumnApiPMTechnicianHistory = params.columnApi;
  //   this.gridApiPMTechnicianHistory.sizeColumnsToFit();
  // }

  // Parameter Popup starts
  openParameterModal(task: any): void {
    if (!this.permissionService.isUserHasPermission(this.isWrite)) {
      this.toaster.warning('user dont have permission');
      return;
    }
    const taskId = task.rowData.ID;
    const unitValue = task.rowData.units.puId;

    let dialogRef = this.dialog.open(ParamaterDialogComponent, {
      disableClose: true,
      width: '80vw !important',
      height: 'auto',
      maxHeight: '90vh',
      minWidth: '80vw',
      data: { unit: unitValue, taskId: taskId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.getTask();
      }
    });
  }
}
